var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-28"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.09 173.46 316.44 180.25 327.91 175.57 324.65 187.52 332.65 196.98 320.27 197.57 313.75 208.09 309.36 196.51 297.33 193.56 307 185.81 306.09 173.46",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.31 268.92 287.67 275.71 299.14 271.03 295.88 282.98 303.87 292.44 291.5 293.03 284.97 303.55 280.59 291.97 268.56 289.02 278.22 281.27 277.31 268.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.75 339.96 212.11 346.75 223.58 342.07 220.32 354.02 228.31 363.48 215.94 364.07 209.41 374.6 205.03 363.01 193 360.06 202.66 352.31 201.75 339.96",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.14 238.81 91.45 242.29 97.33 239.89 95.66 246.01 99.75 250.86 93.41 251.16 90.07 256.56 87.82 250.62 81.66 249.11 86.61 245.13 86.14 238.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.33 220.41 412.63 223.89 418.51 221.49 416.84 227.61 420.94 232.46 414.6 232.76 411.25 238.16 409.01 232.22 402.84 230.71 407.79 226.73 407.33 220.41",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.08 276.95 396.39 281.75 404.49 278.44 402.19 286.88 407.83 293.56 399.1 293.97 394.49 301.4 391.4 293.23 382.9 291.14 389.73 285.67 389.08 276.95",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.84 263.87 231.15 267.35 237.02 264.95 235.35 271.07 239.45 275.92 233.11 276.22 229.76 281.62 227.52 275.68 221.35 274.17 226.3 270.2 225.84 263.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.28 364.75 323.67 366.98 327.42 365.44 326.35 369.35 328.96 372.44 324.92 372.64 322.79 376.08 321.35 372.29 317.42 371.33 320.58 368.79 320.28 364.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.43 255.93 349.81 258.15 353.56 256.62 352.5 260.53 355.11 263.62 351.07 263.81 348.93 267.26 347.5 263.47 343.56 262.5 346.72 259.97 346.43 255.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.84 187.97 125.96 191.93 128.72 194.89 124.69 195.28 122.72 198.82 121.11 195.1 117.14 194.33 120.17 191.65 119.68 187.63 123.17 189.68 126.84 187.97",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.17 108.45 334.29 112.4 337.05 115.37 333.02 115.75 331.05 119.3 329.44 115.58 325.46 114.81 328.49 112.12 328 108.1 331.49 110.16 335.17 108.45",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.66 267.63 148.97 271.11 154.84 268.71 153.17 274.84 157.27 279.68 150.93 279.99 147.59 285.38 145.34 279.45 139.18 277.93 144.13 273.96 143.66 267.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.43 317.28 137.74 320.76 143.61 318.37 141.94 324.49 146.04 329.34 139.7 329.64 136.36 335.03 134.11 329.1 127.95 327.58 132.9 323.61 132.43 317.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.2 166.54 192.51 170.03 198.39 167.63 196.72 173.75 200.81 178.6 194.47 178.9 191.13 184.29 188.88 178.36 182.72 176.84 187.67 172.87 187.2 166.54",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.87 135.7 271.17 139.18 277.05 136.78 275.38 142.9 279.48 147.75 273.14 148.05 269.79 153.45 267.55 147.51 261.38 146 266.33 142.03 265.87 135.7",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.23 126.17 134.58 132.97 146.05 128.29 142.79 140.24 150.78 149.69 138.41 150.29 131.89 160.81 127.5 149.23 115.47 146.28 125.13 138.53 124.23 126.17",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.06 91.38 246.93 95.23 253.42 92.58 251.58 99.34 256.1 104.7 249.1 105.04 245.4 111 242.92 104.44 236.1 102.76 241.58 98.38 241.06 91.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,95.8a14.59,14.59,0,1,1-20.64.06A14.59,14.59,0,0,1,202.76,95.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.59,105.87c.64.64,1.5.36,2.49-.19l-2.37-2.36C187.92,104.42,188,105.29,188.59,105.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.06,106.47l2.35,2.34c.82-1.12.78-2,.21-2.55S195.08,105.89,194.06,106.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.63,97.37a12.46,12.46,0,1,0,17.62-.06A12.45,12.45,0,0,0,183.63,97.37Zm14.23,12.88,1.49,1.48-1.08,1.09-1.48-1.46a8.28,8.28,0,0,1-4.35,2.16l-.74-1.94a7.15,7.15,0,0,0,3.65-1.65l-2.66-2.65c-1.83,1.12-3.88,2.23-5.73.39-1.36-1.35-1.56-3.51.3-5.79l-1.5-1.49,1.08-1.09,1.48,1.47a8,8,0,0,1,3.5-1.9l.8,1.88a7.86,7.86,0,0,0-2.86,1.44l2.68,2.68c1.83-1.12,3.9-2.27,5.75-.43C199.55,105.79,199.73,108,197.86,110.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,200.07a14.59,14.59,0,1,1-20.64.07A14.58,14.58,0,0,1,111.78,200.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.61,210.15c.64.63,1.5.35,2.49-.19l-2.36-2.36C96.94,208.69,97,209.57,97.61,210.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.08,210.74l2.36,2.35c.81-1.12.77-2,.2-2.55S104.1,210.17,103.08,210.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.66,201.64a12.46,12.46,0,1,0,17.61,0A12.46,12.46,0,0,0,92.66,201.64Zm14.23,12.89,1.49,1.48-1.09,1.09-1.47-1.47a8.23,8.23,0,0,1-4.35,2.17l-.75-1.94a7.2,7.2,0,0,0,3.66-1.66l-2.66-2.64c-1.83,1.12-3.89,2.23-5.74.39-1.35-1.35-1.56-3.52.3-5.79l-1.5-1.5,1.09-1.09L97.34,205a8,8,0,0,1,3.5-1.89l.8,1.88a7.64,7.64,0,0,0-2.86,1.44l2.69,2.67c1.83-1.12,3.89-2.27,5.74-.43C108.57,210.06,108.75,212.23,106.89,214.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.18,127.36a14.59,14.59,0,1,1,16-13A14.61,14.61,0,0,1,314.18,127.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.84,110.6c-.9-.09-1.39.67-1.82,1.73l3.33.33C320.28,111.32,319.66,110.69,318.84,110.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.22,113.59l-3.31-.34c.07,1.39.65,2,1.45,2.11S313.79,114.67,314.22,113.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,114.09a12.45,12.45,0,1,0-13.65,11.14A12.46,12.46,0,0,0,328,114.09Zm-19.16-1-2.09-.22.15-1.53,2.07.21a8.18,8.18,0,0,1,2-4.41l1.8,1a7.24,7.24,0,0,0-1.8,3.59l3.73.38c.72-2,1.62-4.18,4.21-3.92,1.91.2,3.43,1.75,3.41,4.69l2.11.21-.15,1.53-2.08-.21a7.93,7.93,0,0,1-1.52,3.68l-1.81-1a7.7,7.7,0,0,0,1.32-2.92l-3.77-.38c-.72,2-1.6,4.21-4.2,4C310.38,117.57,308.88,116,308.88,113.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.52,
    cy: 310.51,
    r: 14.59,
    transform: "translate(-82.7 157.75) rotate(-20.24)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.86,306.64c-.65.63-.38,1.49.15,2.49l2.39-2.32C402.32,306,401.45,306.06,400.86,306.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.17,312.1l-2.38,2.31c1.1.84,2,.81,2.54.25S400.73,313.13,400.17,312.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,301.83a12.45,12.45,0,1,0-.24,17.61A12.45,12.45,0,0,0,409.44,301.83Zm-13.12,14-1.5,1.47-1.08-1.11,1.5-1.45a8.19,8.19,0,0,1-2.09-4.38l1.94-.72a7.33,7.33,0,0,0,1.6,3.69l2.69-2.62c-1.09-1.85-2.16-3.92-.29-5.74,1.37-1.33,3.53-1.5,5.78.4l1.52-1.48,1.07,1.1L406,306.46A8,8,0,0,1,407.8,310l-1.89.77a7.74,7.74,0,0,0-1.4-2.88l-2.71,2.64c1.09,1.85,2.2,3.93.33,5.75C400.76,317.6,398.59,317.74,396.32,315.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5,348.24a22.74,22.74,0,1,1-30.95-8.73A22.75,22.75,0,0,1,230.5,348.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,357.28c.68,1.22,2.09,1.17,3.82.77l-2.55-4.54C204.58,354.81,204.33,356.15,205,357.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.9,360.51l2.53,4.51c1.7-1.32,2-2.63,1.39-3.73C216.12,360,214.67,360.08,212.9,360.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17,342.41a19.41,19.41,0,1,0,26.42,7.45A19.42,19.42,0,0,0,201.17,342.41ZM217,367.8l1.6,2.86-2.09,1.17L214.91,369a12.75,12.75,0,0,1-7.44,1.38l-.3-3.22a11.22,11.22,0,0,0,6.19-.92l-2.85-5.1c-3.22.9-6.77,1.68-8.76-1.87-1.46-2.6-.84-5.93,2.93-8.54l-1.62-2.88,2.09-1.17,1.59,2.83a12.36,12.36,0,0,1,6-1.34l.4,3.16a12.08,12.08,0,0,0-4.91.93l2.89,5.16c3.22-.9,6.8-1.73,8.79,1.81C221.42,361.83,220.76,365.15,217,367.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.9,
    cy: 191.75,
    r: 22.74,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -27.8, 70.5)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.21,189.68c.68,1.22,2.09,1.17,3.81.77l-2.54-4.54C376.83,187.21,376.58,188.56,377.21,189.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.15,192.91l2.52,4.51c1.71-1.32,2-2.63,1.4-3.73C388.37,192.44,386.92,192.48,385.15,192.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.42,174.81a19.41,19.41,0,1,0,26.42,7.46A19.41,19.41,0,0,0,373.42,174.81Zm15.81,25.39,1.6,2.86-2.09,1.17-1.59-2.83a12.71,12.71,0,0,1-7.43,1.38l-.3-3.22a11.22,11.22,0,0,0,6.19-.92l-2.86-5.1c-3.21.9-6.76,1.68-8.75-1.87-1.46-2.6-.84-5.93,2.92-8.54l-1.61-2.88,2.09-1.17,1.59,2.83a12.58,12.58,0,0,1,6.05-1.34l.4,3.16a12.08,12.08,0,0,0-4.91.94l2.89,5.15c3.21-.9,6.8-1.73,8.79,1.81C393.66,194.24,393,197.55,389.23,200.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.76,262.61a20,20,0,1,1-9-26.81A20,20,0,0,1,302.76,262.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,248.53c-.55,1.1.18,2.1,1.32,3.15l2-4.09C285.16,247,284.06,247.51,283.56,248.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.14,255.89l-2,4.07c1.81.59,2.91.16,3.4-.83S286.33,257,285.14,255.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.48,238.42a17.06,17.06,0,1,0,7.66,22.88A17.07,17.07,0,0,0,292.48,238.42Zm-10.62,24.05-1.28,2.58-1.89-.94,1.27-2.55a11.33,11.33,0,0,1-4.68-4.72l2.19-1.81a9.86,9.86,0,0,0,3.73,4l2.3-4.6c-2.25-1.89-4.57-4.09-3-7.29,1.17-2.34,3.89-3.54,7.65-2.1l1.3-2.6,1.89.94L290.08,246a10.93,10.93,0,0,1,4,3.73l-2.1,1.85a10.55,10.55,0,0,0-3.11-3.1l-2.31,4.65c2.24,1.89,4.62,4.08,3,7.28C288.39,262.74,285.66,263.9,281.86,262.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,299.84a20,20,0,1,1-9-26.8A20,20,0,0,1,136,299.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,285.76c-.55,1.11.18,2.1,1.32,3.16l2-4.09C118.4,284.27,117.3,284.75,116.8,285.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,293.13l-2,4.07c1.81.58,2.91.16,3.4-.83S119.57,294.21,118.38,293.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,275.66a17.06,17.06,0,1,0,7.66,22.88A17.05,17.05,0,0,0,125.72,275.66Zm-10.62,24-1.28,2.58-1.89-.94,1.27-2.56a11.27,11.27,0,0,1-4.68-4.72l2.19-1.81a9.89,9.89,0,0,0,3.73,4.05l2.3-4.6c-2.25-1.9-4.57-4.09-3-7.29,1.17-2.35,3.89-3.54,7.65-2.1l1.3-2.6,1.89.94-1.28,2.55a11,11,0,0,1,4,3.73l-2.1,1.86a10.43,10.43,0,0,0-3.11-3.1l-2.31,4.65c2.24,1.89,4.63,4.08,3,7.28C121.63,300,118.9,301.14,115.1,299.71Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-28"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-28",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.41,386.17c0-.32-1.11-32.64-6.35-37.73-5-4.91-10.87-.18-11.12,0l-.64-.77c.07-.06,6.76-5.52,12.46,0,5.53,5.37,6.6,37.07,6.64,38.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,392.54c-.16-1.58-3.6-38.88,10.46-55l.76.66c-13.78,15.82-10.26,53.88-10.23,54.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.51,388.47l-1-.07c0-.43,2.74-43.67-7.53-53.11l.68-.74C108.29,344.32,105.63,386.67,105.51,388.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86,388.44h-1c0-1.19.34-29.28,8.34-33.87a5.74,5.74,0,0,1,5.24-.51c4.85,2,7.25,10.62,7.35,11l-1,.26c0-.08-2.36-8.5-6.77-10.32a4.7,4.7,0,0,0-4.35.45C107.19,359.73,106.86,388.15,106.86,388.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,388.46l-1,0c0-.22,1.2-22.13-4.7-29.83-1.42-1.85-3-2.72-4.56-2.62-3.84.27-7.07,5.91-7.1,6l-.87-.49c.14-.25,3.53-6.16,7.89-6.46,2-.14,3.8.87,5.43,3C105,366,103.81,387.55,103.75,388.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,391.45c-.17-2.13-3.88-52.25,2.67-61.1l.8.59c-6.32,8.56-2.52,59.92-2.48,60.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,359.21s-3.92,1.44-2.75,4.85,13.54,9,13.54,9,5.18-4.76.42-12.49S121.28,356.77,121.18,359.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,359.21s-3.92,1.44-2.75,4.85,13.54,9,13.54,9,5.18-4.76.42-12.49S121.28,356.77,121.18,359.21Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.16,352.72s4.17-.17,4.4,3.42-9,13.53-9,13.53-6.61-2.39-5.19-11.35S103.12,350.51,104.16,352.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.16,352.72s4.17-.17,4.4,3.42-9,13.53-9,13.53-6.61-2.39-5.19-11.35S103.12,350.51,104.16,352.72Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63,335.53s2.78-.3,2.55-2-10.8-6-17,1c0,0,4,6.87,9.77,7S100.63,335.53,100.63,335.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63,335.53s2.78-.3,2.55-2-10.8-6-17,1c0,0,4,6.87,9.77,7S100.63,335.53,100.63,335.53Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,331.41s-2.52,1.22-3.22-.33,6-10.85,15-8.18c0,0,.24,8-4.62,11.08S105.81,331.41,105.81,331.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,331.41s-2.52,1.22-3.22-.33,6-10.85,15-8.18c0,0,.24,8-4.62,11.08S105.81,331.41,105.81,331.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.65,357.84s1.92-1.55-.15-2.3-12.23-.55-12.34,9.52c0,0,11.83,2,13.3-1.87S92.65,357.84,92.65,357.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.65,357.84s1.92-1.55-.15-2.3-12.23-.55-12.34,9.52c0,0,11.83,2,13.3-1.87S92.65,357.84,92.65,357.84Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,335.27s-1.92-1.55.15-2.3,12.23-.54,12.34,9.52c0,0-11.83,2-13.3-1.87S116.77,335.27,116.77,335.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,335.27s-1.92-1.55.15-2.3,12.23-.54,12.34,9.52c0,0-11.83,2-13.3-1.87S116.77,335.27,116.77,335.27Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.52,343.38s-.17-1.88,1.35-1.15,6.81,6.45,1.33,11.88c0,0-7.39-5.48-6.06-8.33S110.52,343.38,110.52,343.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.52,343.38s-.17-1.88,1.35-1.15,6.81,6.45,1.33,11.88c0,0-7.39-5.48-6.06-8.33S110.52,343.38,110.52,343.38Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.93,346.06s1.15-1.5-.53-1.69-9.21,1.82-7.45,9.34c0,0,9.17-.69,9.56-3.81S90.93,346.06,90.93,346.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.93,346.06s1.15-1.5-.53-1.69-9.21,1.82-7.45,9.34c0,0,9.17-.69,9.56-3.81S90.93,346.06,90.93,346.06Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.91 416.33 90.45 416.33 87.06 381.88 125.3 381.88 121.91 416.33",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.91 416.33 90.45 416.33 87.06 381.88 125.3 381.88 121.91 416.33",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.38,
    y: 378.08,
    width: 41.61,
    height: 7.6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.38,
    y: 378.08,
    width: 41.61,
    height: 7.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.57,136.91H173.85a8.85,8.85,0,0,0-8.85,8.85v25a8.84,8.84,0,0,0,8.84,8.85h8.39l-3,10.89,9-10.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,202.57,136.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,136.91H173.85a8.85,8.85,0,0,0-8.85,8.85v25a8.84,8.84,0,0,0,8.84,8.85h8.39l-3,10.89,9-10.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,202.57,136.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71,164.52a1.33,1.33,0,0,1-1-.46l-5.59-6.59a1.31,1.31,0,1,1,2-1.7l4.59,5.42,7.59-8.94a1.31,1.31,0,0,1,2,1.69l-8.59,10.12A1.31,1.31,0,0,1,186.71,164.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.21,
    cy: 158.15,
    r: 14.26,
    transform: "translate(-56.71 179.41) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.15,398.37a53.82,53.82,0,0,1-7.87-9.57c-1.45-2.07-1.74-1.56-3.28-3.6a2.45,2.45,0,0,1,1.39-3.69,22.73,22.73,0,0,0,4-1.19l5.32,3.93c-1,2.51.31,9.59,3.06,12.49C172.73,398.83,169.7,399.79,168.15,398.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.05,269s15.33,43.85,17.32,59.9c1.94,15.7-36.08,56.51-36.08,56.51-.92.7-4.72-4-4.94-5.28,9.44-18.25,15.32-45.29,24.81-51.91C164.41,294.53,161.24,273,161.24,273Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.78,383.82c-.94,1-1.48,1.62-1.48,1.62-.93.7-4.73-4-5-5.28,2-3.87,3.85-8.15,5.6-12.54,6.51-16.28,11.74-34.16,19.22-39.37C164.41,294.53,161.25,273,161.25,273l24.8-3.93s15.34,43.85,17.32,59.9C205.08,342.77,175.76,376.1,168.78,383.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.78,383.82c-.94,1-1.48,1.62-1.48,1.62-.93.7-4.73-4-5-5.28,2-3.87,3.85-8.15,5.6-12.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.14,191.62a15.72,15.72,0,0,1,15.22,1.26c7.52,5.16-2.05,26,0,29.9,0,0-13.05,8-26,1.23,0,0,3.63-2.57.73-9.47S138,192.31,152.14,191.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.14,191.62a15.72,15.72,0,0,1,15.22,1.26c7.52,5.16-2.05,26,0,29.9,0,0-13.05,8-26,1.23,0,0,3.63-2.57.73-9.47S138,192.31,152.14,191.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.94,416.32c-5.33,0-6-.08-9-.18-2.57-.09-3.18.23-5.24.18-1.73,0-1.66-1.69-1.13-3.58.26-1,.67-3,1-4.51l7.82-.57c1.1,2.1,3.58,5.09,6.59,5.5S175.07,416.32,172.94,416.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.27,284.46s1.25,16.13,1.57,27.09c-3-5.35-5.44-10.23-7.42-14.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.61,270.21s-5.71,44.16-9,65.41c-3.43,22.32-3.87,58.13-3,72.73-1.25.72-5.78.22-8.24-.55,0,0-14.82-47.87-3.94-70-7-51.64,3.15-64.29,3.15-64.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.61,270.21s-5.71,44.16-9,65.41c-3.43,22.32-3.87,58.13-3,72.73-1.25.72-5.78.22-8.24-.55,0,0-14.82-47.87-3.94-70-7-51.64,3.15-64.29,3.15-64.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.4,228.16a160.71,160.71,0,0,1,21-.8,10.09,10.09,0,0,0,2.15-.35c7-2,14.33-6,21-9.31a2.17,2.17,0,0,1,2.41,3.59,104.21,104.21,0,0,1-9.92,7.18c-5.35,3.34-11.35,6.95-18.2,7l-17.63,1.4a4.36,4.36,0,0,1-.88-8.68Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,230.17c3-5.13,8.11-5.79,18.13-4,2,3.34.54,12,.54,12l-11.25,4S170.08,232.35,169,230.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,217l-.3,1.85a2.2,2.2,0,0,1-1.18,1.62l-3,1.47a4,4,0,0,1-3.73-.06l-.73-.38c.28-3.11,2.88-6.27,2.88-6.27l.63-1a1.82,1.82,0,0,1,2.52-.59l2,1.24A2.1,2.1,0,0,1,228.55,217Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,239.22c8,17.23,10.35,26.21,11,34.32l28.45-4.5c-.65-9.4-1.14-15-1.82-20.71a87.19,87.19,0,0,0-1.88-11.6c-.77-4-4-8.23-7.9-9.61a7.8,7.8,0,0,0-2.83-.48c-1.42,0-2.9.08-4.33.18a93.07,93.07,0,0,0-12.92,2c-1.22.26-2.4.54-3.51.84a5.21,5.21,0,0,0-.7.23A6.72,6.72,0,0,0,146.55,239.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,214.17c1.78,4,4.37,11.38,2.11,14.58,0,0,3.84-1.21,13,2.63,1.87-3.85-.1-4.67-.1-4.67-4.9-.36-5.58-3.78-5.52-7.1Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,216.39l5.62,3.21a13.76,13.76,0,0,0,.14,2.33c-1.83,0-4.72-1.51-5.34-3.31A6.22,6.22,0,0,1,156.85,216.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,193.3s10-2.74,12.52,5.85-6.26,17.8-16.14,16.31-12-14.52-6.57-19.08S155.83,193.3,155.83,193.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,193.3s10-2.74,12.52,5.85-6.26,17.8-16.14,16.31-12-14.52-6.57-19.08S155.83,193.3,155.83,193.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,206.39c2.32,6.51,3.17,9.31,7.51,11.92,6.53,3.93,14,.12,13.71-6.85-.29-6.26-4-15.86-11.31-17A8.85,8.85,0,0,0,148.1,206.39Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,206.15c.17.55.6.94,1,.85s.51-.6.34-1.16-.6-.93-1-.85S156.68,205.59,156.85,206.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,204.29c.17.56.6.94,1,.85s.51-.6.34-1.16-.6-.93-1-.85S163.63,203.74,163.8,204.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,203.2l1.2-.69S164.83,203.71,164,203.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,206a17,17,0,0,0,3.05,3.08,2.3,2.3,0,0,1-1.84.84Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,212.72a5.49,5.49,0,0,0,.94-.14.16.16,0,0,0,.12-.2.19.19,0,0,0-.22-.12,4.79,4.79,0,0,1-4.08-.89.17.17,0,0,0-.24,0,.15.15,0,0,0,0,.23A5,5,0,0,0,160.72,212.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,212.34a5.51,5.51,0,0,0,3.89,1.69c1.88,0,2.18-1.95,1.12-3.56-1-1.45-3.08-3.2-4.71-2.41S146.17,211,147.48,212.34Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,202.91a.32.32,0,0,0,.22-.13,2.47,2.47,0,0,1,2-1.18.32.32,0,0,0,.33-.32.38.38,0,0,0-.35-.35,3.1,3.1,0,0,0-2.6,1.46.33.33,0,0,0,.11.46A.34.34,0,0,0,154.74,202.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.54,200a.31.31,0,0,0,.22-.09.34.34,0,0,0,0-.48,3.55,3.55,0,0,0-3-1,.31.31,0,0,0-.24.39.37.37,0,0,0,.42.27,2.85,2.85,0,0,1,2.35.83A.35.35,0,0,0,165.54,200Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,205.06l1.2-.7S157.89,205.56,157,205.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.43,194.56s.5,9.75-7.65,12.45V211l-4.23-1s-3.29-2.81-2.36-10,10.68-9.73,18.32-5.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.43,194.56s.5,9.75-7.65,12.45V211l-4.23-1s-3.29-2.81-2.36-10,10.68-9.73,18.32-5.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16,229.93a73,73,0,0,0,7.06,3.19h0c.62.23,1.25.46,1.89.67,3.66,1.23,7.49,2,10.22,1.19a6.7,6.7,0,0,0,4.5-3.62,6.3,6.3,0,0,0,.42-1.22,9.21,9.21,0,0,0,.19-3,7.8,7.8,0,0,0-2.83-.48l-1,0c-.42,0-.83,0-1.25,0-.71,0-1.43.07-2.13.12a93.07,93.07,0,0,0-12.92,2l-.28.06-1,.21c-.78.18-1.55.37-2.28.57A5.21,5.21,0,0,0,150.16,229.93Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.14,229.13a23.86,23.86,0,0,1,4.08,4h0c.62.23,1.25.46,1.89.67a19.57,19.57,0,0,0-5-4.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,226.7a25.76,25.76,0,0,1,4.42,4.66,6.3,6.3,0,0,0,.42-1.22,19.62,19.62,0,0,0-3.59-3.47C170.25,226.67,169.84,226.69,169.42,226.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.14,229.13a23.86,23.86,0,0,1,4.08,4h0c.62.23,1.25.46,1.89.67a19.57,19.57,0,0,0-5-4.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,226.7a25.76,25.76,0,0,1,4.42,4.66,6.3,6.3,0,0,0,.42-1.22,19.62,19.62,0,0,0-3.59-3.47C170.25,226.67,169.84,226.69,169.42,226.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,244.68c2.16,4.95,3.8,9.15,5,12.82,2.79-12.74-2.44-20.13-2.44-20.13C148.8,238.32,150.76,242.8,149,244.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,269a22.42,22.42,0,1,1-22.42-22.42A22.41,22.41,0,0,1,172.87,269Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.45,
    cy: 269.04,
    r: 18.82,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,263.58h0a22.43,22.43,0,1,0,.67,5.46A22.42,22.42,0,0,0,172.2,263.58ZM150.45,290.7A21.67,21.67,0,1,1,172.12,269,21.64,21.64,0,0,1,150.45,290.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.46,261a18.82,18.82,0,0,0-33.69,16.76,18.6,18.6,0,0,1-2.14-8.7A18.82,18.82,0,0,1,167.46,261Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,269A22.42,22.42,0,0,1,131,280.21c.49.36,1,.74,1.59,1.12a21.67,21.67,0,0,0,39.22-15.83c.15-.68.27-1.32.37-1.92A22.31,22.31,0,0,1,172.87,269Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.08,279.2v3.07h-2.26l-.64-.63.64-2.42a14.47,14.47,0,0,1-7.37-2.92l1.87-2.14a10.55,10.55,0,0,0,5.5,2.09v-5.49c-1.82-.45-5.23-1.73-6.08-3.33a7.48,7.48,0,0,1-.24-2.23c0-2.8,2-5.25,6.32-5.66l1.62-3.74.64.63v3.06a27.49,27.49,0,0,1,4.94,1l.64.64-1.13,2.78a11.55,11.55,0,0,0-4.45-1.49V268a37.16,37.16,0,0,1,4.29,1.43,5.65,5.65,0,0,1,2.08,4.09C158.45,276.34,156.39,278.76,152.08,279.2Zm-2.26-11.77v-4.89c-1.95.3-2.77,1.29-2.77,2.5S148.23,267,149.82,267.43Zm5.12,6.35c0-1.35-1.21-2-2.86-2.45v4.87C154.08,275.9,154.94,275,154.94,273.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.44,278.56v3.08h-2.26v-3.06a12,12,0,0,1-6.73-2.28l1.24-2.77a10.57,10.57,0,0,0,5.49,2.09v-5.5c-3.05-.74-6.32-1.73-6.32-5.56,0-2.8,2-5.25,6.32-5.66v-3.1h2.26v3.05a11.84,11.84,0,0,1,5.58,1.67l-1.13,2.78a11.36,11.36,0,0,0-4.45-1.48v5.55c3.05.74,6.38,1.7,6.38,5.52C157.82,275.7,155.75,278.12,151.44,278.56Zm-2.26-11.77V261.9c-2,.3-2.77,1.29-2.77,2.5S147.59,266.32,149.18,266.79Zm5.12,6.35c0-1.35-1.21-2-2.86-2.45v4.87C153.44,275.26,154.3,274.32,154.3,273.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86,273.52l-.74-2a2.5,2.5,0,0,0-1.69-1.55l-3.64-1a4.68,4.68,0,0,0-4.19.88l-.72.6c1,3.43,4.61,6.4,4.61,6.4l.93,1a2.08,2.08,0,0,0,3,.11l1.93-1.83A2.42,2.42,0,0,0,158.86,273.52Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.83,243.13a86.06,86.06,0,0,0-9.71,13,45.2,45.2,0,0,0-2.39,4.63l.21-.81a1,1,0,0,0-.12-.65c1.18,2,4.14,3.54,6.34,4.89,3.41,1.94,7.1,3.69,10.67,5.35a2.18,2.18,0,0,1-1.32,4.11c-6.83-1.5-24.29-5.61-23.38-14.81,2.49-8.28,7.58-15.45,13.41-21.72,4.1-4,10.12,1.8,6.29,6Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16,229.93c-4.76-.58-9.38,5.17-12.57,9.78.41,3.9,6.89,9.88,6.89,9.88l5.07-4S151.86,234.24,150.16,229.93Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Jar--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228,227.64c0,.08.08.17.13.26.12.25.25.5.38.74a29.79,29.79,0,0,0,1.64,2.7c.11.17.23.33.34.49l.14.19c.23.32.46.63.71.93a20.94,20.94,0,0,0,1.43,1.67c.14.16.27.3.42.45a1.37,1.37,0,0,0,.17.17l.29.29a23.93,23.93,0,0,0,2.09,1.84l.49.37,0,0,.2.15a22.39,22.39,0,0,0,2.65,1.65l.65.33a18,18,0,0,0,3.26,1.23c.29.09.59.16.88.22a15.65,15.65,0,0,0,2.86.36c.47,0,.93,0,1.39,0a13,13,0,0,0,9.22-4.82h0c4.56-5.63,5.13-15.19.82-24S246,198.63,238.72,198.78h0a12.34,12.34,0,0,0-1.61.13,13.09,13.09,0,0,0-3.88,1.18,12.92,12.92,0,0,0-4,3l0,0c-.29.32-.56.66-.82,1l0,.05a15.16,15.16,0,0,0-1.28,2.09c-.07.13-.13.26-.19.39s-.26.54-.37.83h0a19.63,19.63,0,0,0-.93,2.93l-.09.4c0,.24-.09.48-.14.72s0,.25-.05.37c-.12.71-.19,1.44-.24,2.18l0,.8v.66c0,.66,0,1.34.09,2,0,.47.09.93.16,1.4l.09.61a.3.3,0,0,0,0,.1c.05.31.11.63.17.94.17.82.38,1.65.62,2.48l.18.55h0a3.66,3.66,0,0,0,.15.43,28.52,28.52,0,0,0,1.33,3.28C227.9,227.46,227.94,227.55,228,227.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,227.64c0,.08.08.17.13.26.12.25.25.5.38.74a29.79,29.79,0,0,0,1.64,2.7c.11.17.23.33.34.49l.14.19c.23.32.46.63.71.93a20.94,20.94,0,0,0,1.43,1.67c.14.16.27.3.42.45a1.37,1.37,0,0,0,.17.17l.29.29a23.93,23.93,0,0,0,2.09,1.84l.49.37,0,0,.2.15a22.39,22.39,0,0,0,2.65,1.65l.65.33a18,18,0,0,0,3.26,1.23c.29.09.59.16.88.22a15.65,15.65,0,0,0,2.86.36c.47,0,.93,0,1.39,0a12.94,12.94,0,0,0,4.81-1.29l4-2a1,1,0,0,0,.54-1.16,1.07,1.07,0,0,0-.07-.19l-18.85-38.48a1.62,1.62,0,0,0-.1-.18h0a1,1,0,0,0-1.23-.28l-4,2a12.92,12.92,0,0,0-4,3l0,0c-.29.32-.56.66-.82,1l0,.05a15.16,15.16,0,0,0-1.28,2.09c-.07.13-.13.26-.19.39s-.26.54-.37.83h0a19.63,19.63,0,0,0-.93,2.93l-.09.4c0,.24-.09.48-.14.72s0,.25-.05.37c-.12.71-.19,1.44-.24,2.18l0,.8v.66c0,.66,0,1.34.09,2,0,.47.09.93.16,1.4l.09.61a.3.3,0,0,0,0,.1c.05.31.11.63.17.94.17.82.38,1.65.62,2.48l.18.55h0a3.66,3.66,0,0,0,.15.43,28.52,28.52,0,0,0,1.33,3.28C227.9,227.46,227.94,227.55,228,227.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,227.64c0,.08.08.17.13.26l18.43-9a.3.3,0,0,0,.13-.39.29.29,0,0,0-.39-.14l-18.43,9C227.9,227.46,227.94,227.55,228,227.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.38,204.18l8.85-4.33a.22.22,0,0,0,.1-.09.27.27,0,0,0,0-.3.29.29,0,0,0-.33-.16l-.06,0-7.72,3.78,0,0c-.29.32-.56.66-.82,1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.54,207.49l11.64-5.7a.29.29,0,1,0-.25-.53l-11,5.4C226.78,206.93,226.65,207.2,226.54,207.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.37,211.54l14.19-6.94a.3.3,0,0,0,.13-.4.29.29,0,0,0-.39-.13l-13.79,6.75C225.46,211.06,225.42,211.3,225.37,211.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.05,215.55l16-7.85a.3.3,0,0,0,.13-.39.29.29,0,0,0-.39-.14l-15.77,7.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39,219.58l17.35-8.49a.3.3,0,0,0,.13-.4.3.3,0,0,0-.39-.13L225.3,219Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,223.66l18.16-8.89.06,0a.3.3,0,0,0-.32-.49L226.2,223.1l.18.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.75,241.71c.47,0,.93,0,1.39,0l7.73-3.79a.29.29,0,0,0,.13-.39.3.3,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,241.13c.29.09.59.16.88.22l11-5.4a.29.29,0,0,0,.13-.39.3.3,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,239.57l.65.33,13.79-6.75a.31.31,0,0,0,.13-.4.29.29,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,237.37l.49.37,0,0L252,230a.27.27,0,0,0,.1-.08.27.27,0,0,0,0-.31.29.29,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.76,234.62c.14.16.27.3.42.45l17.18-8.42a.28.28,0,0,0,.13-.39.29.29,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,231.34c.11.17.23.33.34.49L248.56,223a.29.29,0,0,0,.13-.39.3.3,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.24,199.2l-.4-.83a5,5,0,0,0-.65.27l-3,1.45a12.92,12.92,0,0,0-4,3l0,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.1,206.27l11-5.37-.59-1.21-9.06,4.44,0,.05A15.16,15.16,0,0,0,227.1,206.27Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.6,210.42l13.82-6.77-1-2-11.92,5.83A19.63,19.63,0,0,0,225.6,210.42Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,214.09l15.69-7.68-.82-1.67-14.63,7.17C225.2,212.62,225.13,213.35,225.08,214.09Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.14,217.57l17-8.34-.82-1.66-16.29,8C225.05,216.21,225.08,216.89,225.14,217.57Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.58,220.62l17.87-8.74L243,211l-17.63,8.64C225.46,220,225.52,220.31,225.58,220.62Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.53,224.09l18.47-9-.2-.42-18.42,9h0A3.66,3.66,0,0,0,226.53,224.09Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,230.48l.12.18.45.68a.83.83,0,0,1,.08.12l.12.18.14.19.14.19h0c.23.32.47.63.71.93h0l.06.08c.15.19.3.38.46.56l.31.37c.14.16.28.32.43.47a1.54,1.54,0,0,0,.17.19l.13.14a2.39,2.39,0,0,0,.22.23l.07.08a1.37,1.37,0,0,0,.17.17h0l.29.29h0l0,0c.31.3.63.6,1,.88l.22.19.75.63.15.12.22.16.24.19,0,0h0l.23.17h0l.35.24.15.1.71.47.06,0c.25.16.51.31.77.46l.28.15.33.19.14.07.26.13.25.13.32.15.28.13.54.23.31.12.51.19.35.13.43.13.46.14H243l.2.05c.2.06.41.11.61.15l.07,0,.45.09.26.05.78.11.22,0,.6.06h.25l.3,0h.53l.55,0h.31l.68-.07.18,0a5.81,5.81,0,0,0,.58-.09l.24,0,.6-.14.15,0,.72-.22.2-.07.54-.2.21-.08c.24-.1.48-.2.71-.32l3-1.46c1-.48,1.66-1.2,1.6-1.68a.5.5,0,0,0,0-.13l-18.9-38.61a.76.76,0,0,0-.08-.11h0a1.86,1.86,0,0,0-1.65,0l10.34,21.13-18.05,8.84c-.18-.33-.35-.67-.52-1-5.38-11-3.17-23.15,4.92-27.38l-.31.14c-8.34,4.09-10.68,16.42-5.23,27.55.16.34.34.67.51,1h0v0l0,0c.15.28.31.56.47.83l.16.29Zm7.28,7,15.42-7.55.11.22-15.3,7.5ZM234,234.93l16.75-8.2.17.35-16.63,8.14Zm-2.73-3.22,17.68-8.66.51,1L232,232.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,225.65c5.45,11.13,16.62,16.84,25,12.76s10.68-16.42,5.23-27.54-16.62-16.84-25-12.76S226.59,214.53,232,225.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.14,
    cy: 218.26,
    rx: 14.11,
    ry: 18.83,
    transform: "translate(-70.81 130.94) rotate(-26.09)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,225.65c5.45,11.13,16.62,16.84,25,12.76,5.6-2.74,8.49-9.2,8.14-16.52a28.23,28.23,0,0,0-2.91-11c-5.45-11.13-16.63-16.84-25-12.76-7.08,3.46-9.83,12.86-7.18,22.42h0A28.89,28.89,0,0,0,232,225.65Zm.5-.25a28.63,28.63,0,0,1-1.36-3.27c-3.39-9.8-.83-19.79,6.42-23.34,8.06-3.95,18.86,1.57,24.12,12.32a26.87,26.87,0,0,1,2.84,12.32c-.14,6.37-2.91,11.86-7.89,14.3C248.61,241.68,237.81,236.16,232.54,225.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.13,216.63c-.53-6.44,1.9-12.21,6.79-14.61,7-3.42,16.38,1.37,21,10.71a24.09,24.09,0,0,1,2.33,7.85,23.83,23.83,0,0,0-2.39-8.53c-4.58-9.34-14-14.13-21-10.7C233.79,203.82,231.36,209.92,232.13,216.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,225.65c5.45,11.13,16.62,16.84,25,12.76,5.6-2.74,8.49-9.2,8.14-16.52-.17.49-.36,1-.58,1.54-.14,6.37-2.91,11.86-7.89,14.3-8.06,4-18.86-1.57-24.13-12.33a28.63,28.63,0,0,1-1.36-3.27c-.4-.56-.76-1.09-1.09-1.6A28.89,28.89,0,0,0,232,225.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.73,227l1.2,2.78-1.66.17-.72-.53-.47-2.23a13.73,13.73,0,0,1-6.58-2.07l.55-2.07a9.74,9.74,0,0,0,4.87,1.46l-2.15-5c-1.51-.26-4.52-1.15-5.78-2.53a11.14,11.14,0,0,1-1-2c-1.1-2.53-.55-4.89,2.45-5.59l-.27-3.5.72.53,1.19,2.75a21.24,21.24,0,0,1,4.05.56l.72.53.25,2.59a10,10,0,0,0-3.86-1l2.16,5a34.6,34.6,0,0,1,3.73,1,8.68,8.68,0,0,1,3.13,3.53C256.32,223.9,255.74,226.24,252.73,227Zm-6.25-10.45-1.91-4.41a1.62,1.62,0,0,0-1.07,2.47C244,215.77,245.12,216.22,246.48,216.52Zm6.24,5.34c-.52-1.21-1.66-1.69-3.06-2l1.9,4.39A1.59,1.59,0,0,0,252.72,221.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M252,226.44l1.2,2.78-1.66.17-1.19-2.75a10.81,10.81,0,0,1-5.86-1.55l-.17-2.6A9.85,9.85,0,0,0,249.2,224l-2.15-5c-2.53-.44-5.33-1.09-6.82-4.53-1.1-2.53-.55-4.9,2.45-5.59l-1.21-2.81,1.66-.17,1.19,2.76a10,10,0,0,1,4.77,1.08l.25,2.6a10,10,0,0,0-3.86-1l2.16,5c2.54.44,5.37,1.06,6.86,4.51C255.6,223.38,255,225.71,252,226.44ZM245.76,216l-1.91-4.41a1.62,1.62,0,0,0-1.07,2.47C243.29,215.24,244.4,215.69,245.76,216Zm6.24,5.35c-.52-1.22-1.66-1.7-3.06-2l1.9,4.39A1.59,1.59,0,0,0,252,221.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.6,214.14l-33-8.65a13.89,13.89,0,0,1,6.67-7.38c8.34-4.09,19.51,1.63,25,12.76A28.71,28.71,0,0,1,263.6,214.14Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,338.12c-8.07-37.92-26.4-66.15-40.94-63.06l-17.44,3.72c-14.54,3.09-19.78,36.34-11.71,74.26s26.4,66.15,40.94,63l17.44-3.71C421.45,409.29,426.7,376,418.62,338.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,338.12c-8.07-37.92-26.4-66.15-40.94-63.06l-17.44,3.72c-14.54,3.09-19.78,36.34-11.71,74.26s26.4,66.15,40.94,63l17.44-3.71C421.45,409.29,426.7,376,418.62,338.12Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.86,
    cy: 347.43,
    rx: 26.92,
    ry: 70.2,
    transform: "translate(-64.12 85.66) rotate(-12.02)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,414.13c-2.72.58-10.18-1.88-18.93-15.34-7.65-11.8-14-28.32-17.89-46.54s-4.8-35.89-2.61-49.78c2.5-15.87,8.32-21.16,11-21.74,2-.42,6.42.75,12,6.52a56.31,56.31,0,0,1,6.92,8.83c7.66,11.8,14,28.33,17.88,46.54s4.81,35.89,2.63,49.79a56,56,0,0,1-2.73,10.89C394.61,410.83,391,413.71,389.05,414.13Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,403.3a56.7,56.7,0,0,1-6.91-8.84c-7.65-11.8-14-28.33-17.87-46.54S367.78,312,370,298.14a56.35,56.35,0,0,1,2.71-10.89,56.31,56.31,0,0,1,6.92,8.83c7.66,11.8,14,28.33,17.88,46.54s4.81,35.89,2.63,49.79A56,56,0,0,1,397.38,403.3Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.79,
    y: 226.52,
    width: 131.58,
    height: 12.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.79,
    y: 226.52,
    width: 131.58,
    height: 12.55,
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.7,254.91V394.15A19.87,19.87,0,0,1,347.83,414H229.33a19.86,19.86,0,0,1-19.87-19.87V254.91a19.85,19.85,0,0,1,12.66-18.5H355A19.86,19.86,0,0,1,367.7,254.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.7,254.91V394.15A19.87,19.87,0,0,1,347.83,414H229.33a19.86,19.86,0,0,1-19.87-19.87V254.91a19.85,19.85,0,0,1,12.66-18.5H355A19.86,19.86,0,0,1,367.7,254.91Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.55,
    y: 411,
    width: 140.04,
    height: 5.33,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.55,
    y: 411,
    width: 140.04,
    height: 5.33,
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.36,235.23H222.79a1,1,0,0,1,0-2H354.36a1,1,0,0,1,0,2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.36,235.23H222.79a1,1,0,0,1,0-2H354.36a1,1,0,0,1,0,2Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.36,231.23H222.79a1,1,0,0,1,0-2H354.36a1,1,0,0,1,0,2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.36,231.23H222.79a1,1,0,0,1,0-2H354.36a1,1,0,0,1,0,2Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.36,227.23H222.79a1,1,0,0,1,0-2H354.36a1,1,0,0,1,0,2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.36,227.23H222.79a1,1,0,0,1,0-2H354.36a1,1,0,0,1,0,2Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M365.63,277.63v120.8c-7-11.33-13.23-27.25-17.1-45.39-8.07-37.92-2.82-71.17,11.71-74.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.63,277.63v120.8c-7-11.33-13.23-27.25-17.1-45.39-8.07-37.92-2.82-71.17,11.71-74.26Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.63,279V398.43c-7-11.33-13.23-27.25-17.1-45.39-8.07-37.92-2.82-71.17,11.71-74.26A11.36,11.36,0,0,1,365.63,279Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.63,281.83V391c-5.64-10.83-10.31-24.26-13.39-38.77-3.88-18.21-4.8-35.89-2.62-49.78,2.5-15.87,8.32-21.16,11-21.74A8.25,8.25,0,0,1,365.63,281.83Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.63,277.63v120.8c-7-11.33-13.23-27.25-17.1-45.39-8.07-37.92-2.82-71.17,11.71-74.26Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,227.31a17.06,17.06,0,0,1-.26,1.92c0,.22-.08.43-.13.64-.1.46-.22.92-.36,1.36a16.84,16.84,0,0,1-1.75,4c-.25.41-.52.8-.8,1.18-.11.15-.22.3-.34.44h0c-.26.32-.54.63-.83.93a12.35,12.35,0,0,1-1.44,1.27,1.56,1.56,0,0,1-.2.16h0a12.87,12.87,0,0,1-1.93,1.17c-.23.12-.47.22-.7.32l-.22.08c-.18.08-.36.14-.54.21l-.06,0-.14,0-.65.2-.07,0-.14,0-.61.14-.24,0-.58.1-.18,0-.68.07h-1.38l-.31,0h-.25l-.6-.05h-.08l-.13,0-.33,0-.46-.07-.26-.05-.44-.09-.36-.08-.32-.08-.21-.06-.21-.06-.26-.08h0l-.43-.13-.35-.13-.51-.18-.32-.13-.54-.23-.27-.13-.33-.15-.25-.12-.26-.14-.14-.07-.33-.18-.28-.16-.06,0-.22-.14h0l-.48-.29-.05,0-.36-.24a3.75,3.75,0,0,1-.36-.24l-.15-.1-.35-.24-.19-.15,0,0,0,0-.24-.18-.21-.17-.16-.12q-.37-.3-.75-.63l-.22-.19,0,0h0l-.92-.86,0,0-.3-.3c-.06,0-.1-.1-.16-.16l-.07-.08-.07-.07-.28-.3-.17-.18-.43-.48-.31-.37-.3-.36-.16-.2-.06-.07h0c-.24-.3-.48-.61-.71-.93l-.14-.19-.13-.19-.12-.18-.09-.12-.07-.11c-.13-.18-.25-.38-.38-.57l-.11-.18,0,0c-.13-.2-.26-.41-.38-.62s-.12-.19-.17-.29a2.69,2.69,0,0,1-.16-.29c-.11-.18-.21-.36-.31-.54l0,0h0l-.39-.75c0-.08-.09-.17-.13-.26l-.13-.27,0-.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,238.41l-1.07.52-.26.13h0L253,240.39c-.23.12-.47.22-.7.32l-.22.08c-.18.08-.36.14-.54.21l-.06,0-.14,0-.65.2-.07,0-.14,0-.61.14-.24,0-.58.1-.18,0-.68.07h-1.38l-.31,0h-.25l-.6-.05h-.08l-.13,0-.33,0-.46-.07-.26-.05-.44-.09-.36-.08-.32-.08-.21-.06-.21-.06-.26-.08h0l-.43-.13-.35-.13-.51-.18-.32-.13-.54-.23-.27-.13-.33-.15-.25-.12-.26-.14-.14-.07-.33-.18-.28-.16-.06,0-.22-.14h0l-.48-.29-.05,0-.36-.24a3.75,3.75,0,0,1-.36-.24l-.15-.1-.35-.24-.19-.15,0,0,0,0-.24-.18-.21-.17-.16-.12q-.37-.3-.75-.63l-.22-.19,0,0h0l-.92-.86,0,0-.3-.3c-.06,0-.1-.1-.16-.16l-.07-.08-.07-.07-.28-.3-.17-.18-.43-.48-.31-.37-.3-.36-.16-.2-.06-.07h0c-.24-.3-.48-.61-.71-.93l-.14-.19-.13-.19-.12-.18-.09-.12-.07-.11c-.13-.18-.25-.38-.38-.57l-.11-.18,0,0c-.13-.2-.26-.41-.38-.62s-.12-.19-.17-.29a2.69,2.69,0,0,1-.16-.29c-.11-.18-.21-.36-.31-.54l0,0h0l-.39-.75c0-.08-.09-.17-.13-.26l-.13-.27,0-.06h24.86l.94,1.92.25.52.73,1.48,1,2h0l.71,1.46.26.54.58,1.18.22.44h0l.1.2a1.07,1.07,0,0,1,.07.19v0A1,1,0,0,1,257,238.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.87,237.89l-1.32.65h0l-2.34,1.15-4.06,2h-1.38l4.06-2,1.59-.78,3.2-1.57a.3.3,0,0,1,.39.13A.29.29,0,0,1,255.87,237.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.92,236l-.92.45-5,2.44h0l-1.05.52-4,2-.36-.08-.32-.08-.21-.06,4-2,1-.47h0l4.64-2.27,1.42-.7h0l.53-.26a.26.26,0,0,1,.21,0h0a.25.25,0,0,1,.17.15A.3.3,0,0,1,254.92,236Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.54,233.15l-.16.08-4.09,2-1.51.74h0l-.89.44-2.33,1.14h0l-.73.36-4.06,2-.25-.12-.26-.14-.14-.07,4.05-2h0l.71-.34,1.69-.83,1.36-.67,1-.51,4.09-2,1.24-.61a.29.29,0,0,1,.39.13A.29.29,0,0,1,253.54,233.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.13,230a.28.28,0,0,1-.11.08l-2.43,1.19-4.08,2-2.11,1-2,1-.51.25-.61.3-1.29.63-2.14,1.05-.62.31,0,0,0,0-.24-.18-.21-.17,2-1,2.09-1,.32-.16.29-.14,2.4-1.18,1.39-.68,4.09-2,3.49-1.71a.3.3,0,0,1,.39.13A.31.31,0,0,1,252.13,230Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,227.31l-3.92,1.92-4.09,2-1.09.54-2.14,1-.56.27-.29.14-3.76,1.84-.07-.08-.07-.07-.28-.3,2.84-1.39,1.21-.59.55-.27,2.11-1,.22-.11,4.09-2,3.92-1.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.71,227.31,237,228.62l-1.24.61-.74.36-.51.25-2.84,1.39-1.22.6-.13-.19-.12-.18-.09-.12.22-.11,3.84-1.88.25-.12.26-.13,2-1,1.71-.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.49,237.12l0-.06-.1-.2h0l-.22-.44-.58-1.18-.26-.54-.71-1.46h0l-1-2-.73-1.48-.25-.52-.94-1.92h-2.27l-3.92,1.92-4.09,2-2,1-2.1,1-.08,0-.56.27-3.43,1.68a3.83,3.83,0,0,1-.28-.29l3.42-1.67,0,0L238,233l2.15-1,1.43-.7,4.08-2,3.93-1.92h-6.69l-3.92,1.92-1,.49-2,1-.53.26-.52.26-2.9,1.42c-.25-.31-.48-.62-.71-.94l1-.48,2.45-1.2.51-.25,1.13-.55.85-.42,3.08-1.5h-9l-2.11,1c-.13-.25-.26-.5-.38-.75a2.15,2.15,0,0,1-.14-.26s0,0,0,0h-.77l0,.06.13.27c0,.09.09.18.13.26l.39.75h0l0,0c.1.18.2.36.31.54a2.69,2.69,0,0,0,.16.29c.05.1.11.19.17.29s.25.42.38.62l0,0,.11.18c.13.19.25.39.38.57l.07.11.09.12.12.18.13.19.14.19c.23.32.47.63.71.93h0l.06.07.16.2.3.36.31.37.43.48.17.18.13.15.22.22.07.08c.06.06.1.11.16.16l.3.3,0,0,.92.86h0l0,0,.22.19q.38.33.75.63l.16.12.21.17.24.18,0,0,0,0,.2.14h0l.35.24.15.1a3.75,3.75,0,0,0,.36.24l.36.24.05,0,.48.29h0l.22.14.06,0,.28.16.33.18.14.07.26.14.25.12.33.15.27.13.54.23.32.13.51.18.35.13.43.13h0l.26.08.15.05H243l.21.06.32.08.28.07h.08l.44.09.26.05.46.07.33,0,.13,0h.08l.6.05h.25l.31,0h1.38l.68-.07.18,0,.58-.1.24,0,.61-.14.14,0,.07,0,.65-.2.14,0,.06,0c.18-.07.36-.13.54-.21l.22-.08c.23-.1.47-.2.7-.32l2.71-1.33h0l.26-.13a2.82,2.82,0,0,0,.38-.21h0c.76-.45,1.24-1,1.2-1.44v0A.28.28,0,0,0,257.49,237.12Zm-20.41.49-.2-.15,0,0,2.1-1,1.33-.65.61-.3.47-.23,2-1,2.08-1,4.08-2,2.6-1.27.14-.07v0l.1.2-2.27,1.11-4.08,2-2.39,1.17-1.7.83-.81.39-.62.31-1,.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,227.31c0,.22-.08.45-.13.67-.09.39-.19.77-.3,1.15a.19.19,0,0,1,0,.1,9.16,9.16,0,0,1-.33,1c-.12.33-.25.67-.39,1a10.64,10.64,0,0,1-.48,1c-.1.19-.2.37-.31.55s-.16.28-.25.42a14.3,14.3,0,0,1-1.05,1.53l-.4.47-.28.33-.31.32a5.68,5.68,0,0,1-.57.53,11.35,11.35,0,0,1-2,1.47c-.31.19-.64.37-1,.53s-.45.21-.67.3h0c-.31.13-.61.24-.93.34l-.49.16h0a12.75,12.75,0,0,1-2.68.47,10.6,10.6,0,0,1-1.38,0,14.9,14.9,0,0,1-2.87-.35c-.3-.06-.6-.14-.9-.22l-.32-.09a17.86,17.86,0,0,1-2.92-1.15l-.66-.32h0a21.3,21.3,0,0,1-1.92-1.16l-.69-.48-.2-.15,0,0-.49-.37-.2-.16a25,25,0,0,1-1.9-1.69l-.29-.28,0,0-.14-.14-.42-.45-.44-.49-.78-.92-.21-.26c-.24-.31-.48-.62-.7-.94a.85.85,0,0,1-.14-.19c-.12-.16-.23-.32-.34-.49a.83.83,0,0,1-.08-.12c-.42-.61-.82-1.26-1.2-1.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,227.31a14.53,14.53,0,0,1-.69,1.92c-.09.22-.19.43-.3.64a9.64,9.64,0,0,1-.79,1.36,11.28,11.28,0,0,1-1.64,2,11.13,11.13,0,0,1-1.88,1.46c-.28.17-.58.33-.88.48l-.13.06-.41.19h0a7.34,7.34,0,0,1-.74.27h0a11.69,11.69,0,0,1-6.3.26h0c-.29-.06-.57-.14-.86-.23a12.33,12.33,0,0,1-1.52-.51,18.53,18.53,0,0,1-1.75-.83l-.24-.13,0,0-.57-.34c-.35-.21-.69-.44-1-.68s-.9-.66-1.34-1l-.32-.27-.18-.16-.46-.43a.57.57,0,0,1-.11-.11,17.09,17.09,0,0,1-1.43-1.51,6.4,6.4,0,0,1-.42-.49l-.34-.42-.14-.19q-.19-.24-.36-.48c-.2-.27-.39-.55-.57-.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,227.31c0,.22-.08.45-.13.67-.09.39-.19.77-.3,1.15a.19.19,0,0,1,0,.1,9.16,9.16,0,0,1-.33,1c-.11.34-.24.67-.38,1h0a10.64,10.64,0,0,1-.48,1c-.1.19-.2.37-.31.55s-.15.28-.23.42a13.92,13.92,0,0,1-1.07,1.53c-.12.16-.25.31-.39.47l-.29.33-.31.32a5.68,5.68,0,0,1-.57.53,11.35,11.35,0,0,1-2,1.47c-.31.19-.64.37-1,.53s-.45.21-.67.3h0c-.31.13-.61.24-.93.34l-.49.16h0a12.75,12.75,0,0,1-2.68.47,10.6,10.6,0,0,1-1.38,0,14.9,14.9,0,0,1-2.87-.35c-.3-.06-.6-.14-.9-.22l-.32-.09a17.86,17.86,0,0,1-2.92-1.15l-.66-.32,0,0a21.3,21.3,0,0,1-1.92-1.16l-.69-.48-.2-.15,0,0-.49-.37-.2-.16a25,25,0,0,1-1.9-1.69l-.29-.28,0,0-.14-.14-.42-.45-.44-.49-.78-.92-.21-.26c-.24-.31-.48-.62-.7-.94a.85.85,0,0,1-.14-.19c-.12-.16-.23-.32-.34-.49a.83.83,0,0,1-.08-.12c-.42-.61-.82-1.26-1.2-1.92h.65c.37.62.74,1.22,1.14,1.79l.09.13.25.36.14.19c.24.32.47.63.72.93s.28.35.43.52c.33.39.67.78,1,1.14.14.16.29.31.43.45l.17.16c.08.09.17.17.25.25l0,0a22.77,22.77,0,0,0,2.15,1.82l.18.14.31.23,0,0,.21.14c.4.28.81.55,1.22.79s1,.58,1.51.83l.68.31h0a16.85,16.85,0,0,0,3.46,1.13h0c.33.07.65.13,1,.17h0a13.87,13.87,0,0,0,3.4.09,11.93,11.93,0,0,0,2.13-.4h0a11.33,11.33,0,0,0,2-.75.84.84,0,0,0,.14-.06c.3-.14.58-.3.86-.46a13.4,13.4,0,0,0,2.58-2,12.94,12.94,0,0,0,1.61-2,13.37,13.37,0,0,0,1.12-2,16.59,16.59,0,0,0,.78-2,16.87,16.87,0,0,0,.5-1.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,227.31c0,.22-.08.45-.13.67-.09.39-.19.77-.3,1.15a.19.19,0,0,1,0,.1,9.16,9.16,0,0,1-.33,1c-.11.34-.24.67-.38,1h0a10.64,10.64,0,0,1-.48,1c-.1.19-.2.37-.31.55s-.15.28-.23.42a13.92,13.92,0,0,1-1.07,1.53c-.12.16-.25.31-.39.47l-.29.33-.31.32a5.68,5.68,0,0,1-.57.53,11.35,11.35,0,0,1-2,1.47c-.31.19-.64.37-1,.53s-.45.21-.67.3h0c-.31.13-.61.24-.93.34l-.49.16h0a12.75,12.75,0,0,1-2.68.47,10.6,10.6,0,0,1-1.38,0,14.9,14.9,0,0,1-2.87-.35c-.3-.06-.6-.14-.9-.22l-.32-.09a17.86,17.86,0,0,1-2.92-1.15l-.66-.32,0,0a21.3,21.3,0,0,1-1.92-1.16l-.69-.48-.2-.15,0,0-.49-.37-.2-.16a25,25,0,0,1-1.9-1.69l-.29-.28,0,0-.14-.14-.42-.45-.44-.49-.78-.92-.21-.26c-.24-.31-.48-.62-.7-.94a.85.85,0,0,1-.14-.19c-.12-.16-.23-.32-.34-.49a.83.83,0,0,1-.08-.12c-.42-.61-.82-1.26-1.2-1.92h.65c.37.62.74,1.22,1.14,1.79l.09.13.25.36.14.19c.24.32.47.63.72.93s.28.35.43.52c.33.39.67.78,1,1.14.14.16.29.31.43.45l.17.16c.08.09.17.17.25.25l0,0a22.77,22.77,0,0,0,2.15,1.82l.18.14.31.23,0,0,.21.14c.4.28.81.55,1.22.79s1,.58,1.51.83l.68.31h0a16.85,16.85,0,0,0,3.46,1.13h0c.33.07.65.13,1,.17h0a13.87,13.87,0,0,0,3.4.09,11.93,11.93,0,0,0,2.13-.4h0a11.33,11.33,0,0,0,2-.75.84.84,0,0,0,.14-.06c.3-.14.58-.3.86-.46a13.4,13.4,0,0,0,2.58-2,12.94,12.94,0,0,0,1.61-2,13.37,13.37,0,0,0,1.12-2,16.59,16.59,0,0,0,.78-2,16.87,16.87,0,0,0,.5-1.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.77,227.31c0,.22-.08.45-.13.67-.09.39-.19.77-.3,1.15a.19.19,0,0,1,0,.1,9.16,9.16,0,0,1-.33,1c-.11.34-.24.67-.38,1h0a10.64,10.64,0,0,1-.48,1c-.1.19-.2.37-.31.55s-.15.28-.23.42a13.92,13.92,0,0,1-1.07,1.53c-.12.16-.25.31-.39.47l-.29.33-.31.32a5.68,5.68,0,0,1-.57.53H234.58l-.92-.86,0,0-.3-.3c-.06,0-.1-.1-.16-.16l-.07-.08-.22-.22-.13-.15-.17-.18-.43-.48-.31-.37-.3-.36-.16-.2-.06-.07h0c-.24-.3-.48-.61-.71-.93l-.14-.19-.13-.19-.12-.18-.09-.12-.07-.11c-.13-.18-.25-.38-.38-.57l-.11-.18,0,0c-.13-.2-.26-.41-.38-.62s-.12-.19-.17-.29a2.69,2.69,0,0,1-.16-.29c-.11-.18-.21-.36-.31-.54l0,0h0l-.39-.75c0-.08-.09-.17-.13-.26l-.13-.27,0-.06Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.94,236.41a11.35,11.35,0,0,1-2,1.47c-.31.19-.64.37-1,.53l-1.07.52-.26.13h0L253,240.39c-.23.12-.47.22-.7.32l-.22.08c-.18.08-.36.14-.54.21l-.06,0-.14,0-.65.2-.07,0-.14,0-.61.14-.24,0-.58.1-.18,0-.68.07h-1.38l-.31,0h-.25l-.6-.05h-.08l-.13,0-.33,0-.46-.07-.26-.05-.44-.09h-.08l-.28-.07-.32-.08-.21-.06H243l-.15-.05-.26-.08h0l-.43-.13-.35-.13-.51-.18-.32-.13-.54-.23-.27-.13-.33-.15-.25-.12-.26-.14-.14-.07-.33-.18-.28-.16-.06,0-.22-.14h0l-.48-.29-.05,0-.36-.24a3.75,3.75,0,0,1-.36-.24l-.15-.1-.35-.24-.19-.15,0,0,0,0-.24-.18-.21-.17-.16-.12q-.37-.3-.75-.63l-.22-.19,0,0Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.57,233.23a13.92,13.92,0,0,1-1.07,1.53c-.12.16-.25.31-.39.47H233.34c-.06,0-.1-.1-.16-.16l-.07-.08-.22-.22-.13-.15-.17-.18-.43-.48-.31-.37-.3-.36Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.31,229.23a9.16,9.16,0,0,1-.33,1c-.11.34-.24.67-.38,1H230.07c-.13-.18-.25-.38-.38-.57l-.11-.18,0,0c-.13-.2-.26-.41-.38-.62s-.12-.19-.17-.29a2.69,2.69,0,0,1-.16-.29Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.24,318.79c0,.09-.09.17-.13.25-.13.25-.27.49-.41.72a28.16,28.16,0,0,1-1.69,2.59l-.35.47a1.33,1.33,0,0,0-.14.19c-.24.3-.49.6-.74.89-.46.56-.95,1.09-1.45,1.59l-.43.42-.17.16-.3.28a23,23,0,0,1-2.12,1.74l-.49.35,0,0-.2.14a22.93,22.93,0,0,1-2.65,1.53l-.65.31a19.45,19.45,0,0,1-3.25,1.1l-.87.18a15.1,15.1,0,0,1-2.82.26c-.46,0-.92,0-1.37-.08a12.78,12.78,0,0,1-4.67-1.42,12.94,12.94,0,0,1-4.22-3.62h0c-4.29-5.68-4.53-15.08,0-23.59s12.48-13.56,19.59-13.16h0a11.94,11.94,0,0,1,1.58.18,12.48,12.48,0,0,1,3.77,1.29,12.65,12.65,0,0,1,3.79,3.09l0,0c.27.32.52.66.76,1a.21.21,0,0,1,0,.06,13.79,13.79,0,0,1,1.19,2.09l.18.39c.12.27.23.54.33.83h0a18.08,18.08,0,0,1,.82,2.91c0,.13,0,.26.08.4s.08.47.11.71,0,.24,0,.36a21.52,21.52,0,0,1,.16,2.15c0,.26,0,.52,0,.79s0,.42,0,.64q0,1-.15,2-.09.69-.21,1.38c0,.19-.07.39-.11.59a.29.29,0,0,1,0,.09c-.06.31-.13.62-.2.93q-.29,1.2-.69,2.4l-.19.54h0l-.16.42a28.75,28.75,0,0,1-1.42,3.17A2.15,2.15,0,0,1,258.24,318.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.24,318.79c0,.09-.09.17-.13.25-.13.25-.27.49-.41.72a28.16,28.16,0,0,1-1.69,2.59l-.35.47a1.33,1.33,0,0,0-.14.19c-.24.3-.49.6-.74.89-.46.56-.95,1.09-1.45,1.59l-.43.42-.17.16-.3.28a23,23,0,0,1-2.12,1.74l-.49.35,0,0-.2.14a22.93,22.93,0,0,1-2.65,1.53l-.65.31a19.45,19.45,0,0,1-3.25,1.1l-.87.18a15.1,15.1,0,0,1-2.82.26c-.46,0-.92,0-1.37-.08a12.78,12.78,0,0,1-4.67-1.42l-3.91-2.08a1,1,0,0,1-.48-1.16.62.62,0,0,1,.07-.19l19.79-37.15a1,1,0,0,1,.12-.16v0a1,1,0,0,1,1.22-.23l3.9,2.08a12.65,12.65,0,0,1,3.79,3.09l0,0c.27.32.52.66.76,1a.21.21,0,0,1,0,.06,13.79,13.79,0,0,1,1.19,2.09l.18.39c.12.27.23.54.33.83h0a18.08,18.08,0,0,1,.82,2.91c0,.13,0,.26.08.4s.08.47.11.71,0,.24,0,.36a21.52,21.52,0,0,1,.16,2.15c0,.26,0,.52,0,.79s0,.42,0,.64q0,1-.15,2-.09.69-.21,1.38c0,.19-.07.39-.11.59a.29.29,0,0,1,0,.09c-.06.31-.13.62-.2.93q-.29,1.2-.69,2.4l-.19.54h0l-.16.42a28.75,28.75,0,0,1-1.42,3.17A2.15,2.15,0,0,1,258.24,318.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.24,318.79c0,.09-.09.17-.13.25l-17.8-9.48a.29.29,0,0,1,.27-.51l17.8,9.48A2.15,2.15,0,0,1,258.24,318.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.64,295.75l-8.54-4.56a.28.28,0,0,1,.2-.52l.07,0,7.45,4,0,0c.27.32.52.66.76,1A.21.21,0,0,1,258.64,295.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.34,299.06l-11.24-6a.29.29,0,0,1,.27-.51L260,298.23C260.13,298.5,260.24,298.77,260.34,299.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35,303.08l-13.7-7.3a.28.28,0,0,1-.11-.39.28.28,0,0,1,.38-.12l13.32,7.1C261.28,302.6,261.32,302.84,261.35,303.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,307l-15.47-8.25a.28.28,0,0,1-.12-.38.28.28,0,0,1,.39-.12l15.22,8.11C261.55,306.59,261.54,306.8,261.53,307Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.06,311l-16.75-8.92a.29.29,0,0,1-.11-.39.28.28,0,0,1,.39-.12l16.58,8.84C261.14,310.57,261.1,310.77,261.06,311Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,314.94l-17.54-9.34,0,0a.29.29,0,0,1-.07-.35.3.3,0,0,1,.39-.12l17.46,9.3-.19.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.35,332c-.46,0-.92,0-1.37-.08l-7.45-4a.29.29,0,0,1,.27-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,331.54l-.87.18-10.65-5.67a.28.28,0,0,1-.11-.38.29.29,0,0,1,.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.94,330.13l-.65.31L233,323.34a.29.29,0,0,1,.27-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31,328.09l-.49.35,0,0-15.23-8.11a.26.26,0,0,1-.09-.09.25.25,0,0,1,0-.3.28.28,0,0,1,.38-.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,325.49l-.43.42-16.59-8.83a.3.3,0,0,1-.12-.39.28.28,0,0,1,.39-.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,322.35l-.35.47-17.46-9.3a.29.29,0,1,1,.27-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,290.56l.43-.8a4.77,4.77,0,0,1,.62.28l2.87,1.53a12.65,12.65,0,0,1,3.79,3.09l0,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,297.84l-10.59-5.64.62-1.17,8.74,4.66a.21.21,0,0,1,0,.06A13.79,13.79,0,0,1,259.83,297.84Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.16,302l-13.34-7.11,1-1.93,11.49,6.13A18.08,18.08,0,0,1,261.16,302Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.55,305.59l-15.15-8.07.86-1.61,14.13,7.53A21.52,21.52,0,0,1,261.55,305.59Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.38,309,245,300.25l.86-1.61L261.53,307Q261.5,308,261.38,309Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84,312l-17.25-9.19L244,302l17,9.07C261,311.37,260.91,311.68,260.84,312Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.8,315.36,242,305.86l.21-.41L260,314.93h0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,320.88l.18-.27.49-.8v-.05h0c.19-.32.37-.64.54-1,5.73-10.74,3.84-22.93-4.21-27.22l-.3-.15c7.8,4.42,9.56,16.45,3.91,27.05-.17.33-.35.65-.54,1l-17.43-9.28,10.87-20.4a1.83,1.83,0,0,0-1.63,0v0a.28.28,0,0,0-.09.1L229,327.11a.28.28,0,0,0,0,.13c-.08.46.55,1.19,1.51,1.7l2.88,1.54c.22.12.45.23.68.33l.2.09.53.22.2.07c.23.09.46.16.7.24l.14,0,.59.16.23.05.57.11.17,0q.33.06.66.09h.07l.24,0,.54,0h1.06l.59,0h.21l.78-.09.26,0,.44-.07h.07l.6-.13.2,0,.06,0,.45-.11.43-.12.35-.11.5-.17.31-.11.54-.21.28-.12.33-.13.24-.12.26-.12.15-.07.33-.17.27-.14c.26-.13.52-.28.78-.42l.05,0,.72-.44.15-.1.35-.22h0l.23-.16h0l0,0,.24-.17.22-.15.15-.12c.26-.19.51-.38.76-.59l.23-.18c.32-.27.65-.54,1-.83l0,0h0l.29-.28h0l.17-.16.07-.07.22-.22.14-.13.17-.18.44-.46.31-.34.47-.54.06-.07h0c.25-.29.49-.59.73-.9h0a1.33,1.33,0,0,1,.14-.19l.13-.18.13-.17.09-.12.46-.65.12-.17Zm-8,7.39-14.77-7.86.12-.22,14.88,7.93Zm2.85-2.24-16.06-8.56.18-.33,16.17,8.61Zm2.35-2.45-16.87-9,.53-1,17.07,9.09C254.67,323,254.43,323.29,254.18,323.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,316.71c-5.72,10.74-16.89,16-24.94,11.68s-9.93-16.47-4.21-27.21,16.89-16,24.94-11.69S260.06,306,254.33,316.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.76,
    cy: 308.94,
    rx: 18.5,
    ry: 13.86,
    transform: "translate(-145.64 375.27) rotate(-61.95)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42,311.75h0c2.92-9.3.53-18.61-6.3-22.25-8.05-4.29-19.21.94-24.94,11.69A27.85,27.85,0,0,0,222,311.91c-.58,7.17,2,13.6,7.45,16.48,8,4.29,19.21-.94,24.93-11.68A29,29,0,0,0,256.42,311.75Zm-26.68,16c-4.81-2.56-7.34-8-7.27-14.31a26.43,26.43,0,0,1,3.2-12c5.53-10.39,16.32-15.44,24.11-11.3,7,3.73,9.17,13.63,5.51,23.14a28.84,28.84,0,0,1-1.45,3.17C248.31,326.83,237.52,331.89,229.74,327.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.54,307.85c.74-6.31-1.45-12.06-6.17-14.57-6.76-3.6-16.13.79-20.94,9.81a23.85,23.85,0,0,0-2.55,7.63,23.66,23.66,0,0,1,2.64-8.3c4.81-9,14.18-13.41,20.94-9.81C253.34,295.21,255.52,301.28,254.54,307.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,316.71c-5.72,10.74-16.88,16-24.93,11.68-5.41-2.88-8-9.31-7.45-16.48.16.48.33,1,.52,1.52-.07,6.27,2.46,11.75,7.27,14.31,7.78,4.15,18.57-.91,24.1-11.29a28.84,28.84,0,0,0,1.45-3.17c.41-.54.79-1,1.13-1.53A29,29,0,0,1,254.33,316.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.63,319l-.76,3-1.66,0-.31-.62L236,319a7,7,0,0,1-4.71-2.88l1.91-2.05a5.09,5.09,0,0,0,3.54,2.06l1.35-5.31c-1.23-.44-3.42-1.7-3.66-3.25a9.24,9.24,0,0,1,.38-2.15,7,7,0,0,1,6-5.43l2.11-3.6.32.62-.76,3a13.19,13.19,0,0,1,3.39,1l.31.62-1.51,2.68a5.43,5.43,0,0,0-2.92-1.47l-1.37,5.36a17.31,17.31,0,0,1,2.81,1.42,5.23,5.23,0,0,1,.53,4A7.07,7.07,0,0,1,237.63,319Zm1.24-11.37,1.21-4.72a3.15,3.15,0,0,0-2.66,2.39C237.09,306.57,237.81,307.16,238.87,307.62Zm2.2,6.17c.34-1.3-.4-1.92-1.5-2.39l-1.2,4.7A3.12,3.12,0,0,0,241.07,313.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M237.32,318.37l-.76,3-1.66,0,.75-2.95a5.78,5.78,0,0,1-4.4-2.25l1.6-2.67a5.09,5.09,0,0,0,3.53,2.06l1.36-5.31c-2.06-.74-4.23-1.72-3.29-5.4a7,7,0,0,1,6.06-5.43l.76-3,1.66,0-.75,3a5.66,5.66,0,0,1,3.7,1.65l-1.52,2.68a5.37,5.37,0,0,0-2.91-1.47l-1.37,5.36c2.06.74,4.28,1.69,3.33,5.38A7,7,0,0,1,237.32,318.37ZM238.56,307l1.21-4.72a3.14,3.14,0,0,0-2.66,2.39C236.78,305.94,237.5,306.54,238.56,307Zm2.2,6.17c.33-1.3-.4-1.92-1.5-2.39l-1.2,4.7A3.12,3.12,0,0,0,240.76,313.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,316.71c-5.72,10.74-16.89,16-24.94,11.68s-9.93-16.47-4.21-27.21,16.89-16,24.94-11.69S260.06,306,254.33,316.71Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.15,
    y: 398.71,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.32,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,275.32,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,254.39,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.52,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,256.52,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,259.61,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,263,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.75,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,266.75,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,270.8,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.25,399.3h0a.29.29,0,0,1,.28.29v8.68a.29.29,0,0,1-.28.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,296.25,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.11,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,294.11,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,291,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,287.61,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.88,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,283.88,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,279.83,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.48,399.64v8.62a.93.93,0,0,1-.93.94H254.08a.93.93,0,0,1-.88-.64h23.24V399.3h3.91v9.26h1.14V399.3h2.9v9.26h.38V399.3h3.1v9.26h.25V399.3h9.3A1,1,0,0,1,297.48,399.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.55,398.71H254.08a.93.93,0,0,0-.93.93v8.62a.73.73,0,0,0,0,.3h.91V399.3h.53v9.26H256V399.3h.84v9.26H259V399.3h1.2v9.26H262V399.3h1.28v9.26h1.83V399.3h2v9.26h.92V399.3h3v9.26h.46V399.3h25.88A.94.94,0,0,0,296.55,398.71Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.17,
    y: 388.34,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,398.19h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,276.34,398.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,398.19h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,255.41,398.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,398.19h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,257.54,398.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,398.19h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.28.29v8.68A.29.29,0,0,1,260.64,398.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.05,398.19h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.28.28,0,0,1,.28.29v8.68A.28.28,0,0,1,264.05,398.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.78,398.19h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.28.28,0,0,1,.28.29v8.68A.28.28,0,0,1,267.78,398.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.82,398.19h0a.29.29,0,0,1-.28-.29v-8.68a.29.29,0,0,1,.28-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,271.82,398.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.27,388.93h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,297.27,388.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,388.93h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.28-.29v-8.68A.29.29,0,0,1,295.13,388.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,388.93h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,292,388.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.63,388.93h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,288.63,388.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.9,388.93h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,284.9,388.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.85,388.93h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,280.85,388.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.51,389.27v8.63a.94.94,0,0,1-.94.93H255.1a.93.93,0,0,1-.88-.64h23.24v-9.26h3.91v9.26h1.14v-9.26h2.91v9.26h.38v-9.26h3.09v9.26h.25v-9.26h9.3A.8.8,0,0,1,298.51,389.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.57,388.34H255.1a.93.93,0,0,0-.93.93v8.63a.93.93,0,0,0,.05.29h.91v-9.26h.54v9.26H257v-9.26h.84v9.26H260v-9.26h1.19v9.26h1.84v-9.26h1.27v9.26h1.84v-9.26h2v9.26h.91v-9.26h3v9.26h.46v-9.26h25.88A.92.92,0,0,0,297.57,388.34Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.42,
    y: 377.97,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.59,387.82h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,272.59,387.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,387.82h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,251.66,387.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.79,387.82h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,253.79,387.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,387.82h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,256.88,387.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.29,387.82h0a.29.29,0,0,1-.28-.29v-8.68a.29.29,0,0,1,.28-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,260.29,387.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,387.82h0a.28.28,0,0,1-.28-.29v-8.68a.28.28,0,0,1,.28-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,264,387.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.07,387.82h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,268.07,387.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.52,378.56h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,293.52,378.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.38,378.56h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,291.38,378.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.29,378.56h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,288.29,378.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.88,378.56h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,284.88,378.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,378.56h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,281.15,378.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,378.56h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,277.1,378.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.76,378.9v8.63a.94.94,0,0,1-.94.93H251.35a.93.93,0,0,1-.88-.64h23.24v-9.26h3.91v9.26h1.14v-9.26h2.9v9.26H282v-9.26h3.1v9.26h.25v-9.26h9.3A1,1,0,0,1,294.76,378.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.82,378H251.35a.93.93,0,0,0-.93.93v8.63a.93.93,0,0,0,.05.29h.91v-9.26h.54v9.26h1.32v-9.26h.84v9.26h2.2v-9.26h1.19v9.26h1.84v-9.26h1.27v9.26h1.84v-9.26h2v9.26h.91v-9.26h3v9.26h.46v-9.26h25.88A.92.92,0,0,0,293.82,378Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.15,
    y: 367.6,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.32,377.45h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,275.32,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,377.45h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,254.39,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.52,377.45h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,256.52,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61,377.45h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,259.61,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,377.45h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,263,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.75,377.45h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,266.75,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,377.45h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,270.8,377.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.25,368.19h0a.29.29,0,0,1,.28.29v8.68a.29.29,0,0,1-.28.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,296.25,368.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.11,368.19h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,294.11,368.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,368.19h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,291,368.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,368.19h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,287.61,368.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.88,368.19h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,283.88,368.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,368.19h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,279.83,368.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.48,368.53v8.63a.93.93,0,0,1-.93.93H254.08a.93.93,0,0,1-.88-.64h23.24v-9.26h3.91v9.26h1.14v-9.26h2.9v9.26h.38v-9.26h3.1v9.26h.25v-9.26h9.3A1,1,0,0,1,297.48,368.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.55,367.6H254.08a.93.93,0,0,0-.93.93v8.63a.71.71,0,0,0,0,.29h.91v-9.26h.53v9.26H256v-9.26h.84v9.26H259v-9.26h1.2v9.26H262v-9.26h1.28v9.26h1.83v-9.26h2v9.26h.92v-9.26h3v9.26h.46v-9.26h25.88A.94.94,0,0,0,296.55,367.6Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.9,362.84l-20.19,3.26-21.27,3.42a1.18,1.18,0,0,1-1.35-1l-.77-4.81-.52-3.23a1.17,1.17,0,0,1,1-1.34l41.46-6.68a1.17,1.17,0,0,1,1.34,1l1.3,8A1.17,1.17,0,0,1,272.9,362.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.07,365.55h0a.29.29,0,0,1-.34-.24l-1.38-8.57a.3.3,0,0,1,.24-.33h0a.29.29,0,0,1,.33.24l1.38,8.57A.28.28,0,0,1,252.07,365.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.4,368.88h0a.29.29,0,0,1-.33-.24l-1.38-8.57a.29.29,0,0,1,.24-.33h0a.28.28,0,0,1,.33.24l1.38,8.57A.28.28,0,0,1,231.4,368.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.51,368.54h0a.28.28,0,0,1-.33-.24l-1.38-8.57a.28.28,0,0,1,.24-.33h0a.29.29,0,0,1,.33.24l1.38,8.57A.29.29,0,0,1,233.51,368.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.56,368.05h0a.29.29,0,0,1-.33-.24l-1.38-8.57a.28.28,0,0,1,.24-.33h0a.28.28,0,0,1,.33.24l1.38,8.57A.29.29,0,0,1,236.56,368.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.93,367.51h0a.29.29,0,0,1-.33-.24l-1.38-8.57a.28.28,0,0,1,.24-.33h0a.29.29,0,0,1,.33.23l1.38,8.58A.3.3,0,0,1,239.93,367.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.61,366.91h0a.28.28,0,0,1-.33-.24l-1.38-8.57a.29.29,0,0,1,.24-.33h0a.29.29,0,0,1,.33.24l1.38,8.57A.28.28,0,0,1,243.61,366.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.61,366.27h0a.28.28,0,0,1-.33-.24l-1.38-8.57a.28.28,0,0,1,.24-.33h0a.29.29,0,0,1,.33.24l1.38,8.57A.29.29,0,0,1,247.61,366.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26,353.08h0a.31.31,0,0,1,.33.24l1.38,8.57a.3.3,0,0,1-.24.34h0a.29.29,0,0,1-.33-.24L271,353.42A.29.29,0,0,1,271.26,353.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.15,353.42h0a.29.29,0,0,1,.33.24l1.38,8.57a.28.28,0,0,1-.24.33h0a.28.28,0,0,1-.33-.23l-1.38-8.58A.3.3,0,0,1,269.15,353.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.1,353.91h0a.3.3,0,0,1,.33.24l1.38,8.57a.3.3,0,0,1-.24.34h0a.29.29,0,0,1-.33-.24l-1.38-8.57A.29.29,0,0,1,266.1,353.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.73,354.46h0a.28.28,0,0,1,.33.24l1.38,8.57a.29.29,0,0,1-.24.33h0a.29.29,0,0,1-.33-.24l-1.38-8.57A.29.29,0,0,1,262.73,354.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,355.05h0a.28.28,0,0,1,.33.24l1.38,8.57a.29.29,0,0,1-.24.33h0a.28.28,0,0,1-.33-.24l-1.38-8.57A.28.28,0,0,1,259.05,355.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05,355.69h0a.29.29,0,0,1,.33.24l1.38,8.57a.28.28,0,0,1-.24.33h0a.28.28,0,0,1-.33-.23L254.81,356A.3.3,0,0,1,255.05,355.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,353.23l1.37,8.51a.92.92,0,0,1-.77,1.07l-41.93,6.75a.93.93,0,0,1-1-.49l22.94-3.7-1.47-9.14,3.86-.62,1.48,9.14,1.12-.18-1.47-9.14,2.86-.46,1.48,9.14.37-.06-1.47-9.14,3.05-.49,1.48,9.14.25,0-1.48-9.14,9.19-1.48A.92.92,0,0,1,272.53,353.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.47,352.45l-41.94,6.75a.94.94,0,0,0-.77,1.07l1.37,8.52a.94.94,0,0,0,.1.28l.9-.15-1.48-9.14.53-.08,1.48,9.14,1.31-.21-1.48-9.14.83-.14,1.47,9.14,2.17-.35L234.49,359l1.18-.19,1.47,9.13,1.81-.29-1.47-9.14,1.26-.2,1.47,9.14,1.81-.29L240.55,358l2-.32,1.47,9.14.9-.14-1.47-9.14,3-.48,1.47,9.14.46-.08L246.87,357l25.55-4.11A1,1,0,0,0,271.47,352.45Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,366.1l-21.27,3.42a1.18,1.18,0,0,1-1.35-1l-.77-4.81C241.6,358.94,249.52,363.51,252.71,366.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08,378.88,226,406.25l-2.48,2.5a1.16,1.16,0,0,1-1.65,0L216.11,403a1.16,1.16,0,0,1,0-1.65l7.27-7.36,22.25-22.51a1.18,1.18,0,0,1,1.66,0l5.79,5.73A1.17,1.17,0,0,1,253.08,378.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.86,393.37h0a.3.3,0,0,1-.41,0l-6.17-6.1a.3.3,0,0,1,0-.41h0a.29.29,0,0,1,.41,0l6.17,6.1A.29.29,0,0,1,237.86,393.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.15,408.25h0a.29.29,0,0,1-.41,0l-6.17-6.11a.28.28,0,0,1,0-.41h0a.28.28,0,0,1,.4,0l6.18,6.1A.3.3,0,0,1,223.15,408.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.65,406.74h0a.3.3,0,0,1-.41,0l-6.17-6.1a.28.28,0,0,1,0-.41h0a.27.27,0,0,1,.4,0l6.18,6.1A.3.3,0,0,1,224.65,406.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.82,404.54h0a.3.3,0,0,1-.41,0l-6.17-6.1a.3.3,0,0,1,0-.41h0a.29.29,0,0,1,.41,0l6.17,6.1A.29.29,0,0,1,226.82,404.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.22,402.11h0a.28.28,0,0,1-.41,0l-6.17-6.1a.28.28,0,0,1,0-.41h0a.3.3,0,0,1,.41,0l6.17,6.1A.3.3,0,0,1,229.22,402.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,399.46h0a.3.3,0,0,1-.41,0l-6.17-6.1a.3.3,0,0,1,0-.41h0a.3.3,0,0,1,.41,0l6.17,6.1A.29.29,0,0,1,231.84,399.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,396.58h0a.3.3,0,0,1-.41,0l-6.17-6.1a.29.29,0,0,1,0-.41h0a.3.3,0,0,1,.41,0l6.18,6.1A.3.3,0,0,1,234.69,396.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,372h0a.3.3,0,0,1,.41,0l6.17,6.1a.29.29,0,0,1,0,.41h0a.29.29,0,0,1-.41,0L246,372.38A.3.3,0,0,1,246,372Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.49,373.49h0a.3.3,0,0,1,.41,0l6.17,6.1a.29.29,0,0,1,0,.41h0a.29.29,0,0,1-.41,0l-6.18-6.1A.3.3,0,0,1,244.49,373.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.32,375.69h0a.3.3,0,0,1,.41,0l6.17,6.1a.3.3,0,0,1,0,.41h0a.3.3,0,0,1-.41,0l-6.17-6.1A.3.3,0,0,1,242.32,375.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.92,378.12h0a.29.29,0,0,1,.41,0l6.17,6.11a.28.28,0,0,1,0,.4h0a.29.29,0,0,1-.41,0l-6.18-6.11A.28.28,0,0,1,239.92,378.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.3,380.77h0a.29.29,0,0,1,.41,0l6.17,6.1a.29.29,0,0,1,0,.41h0a.3.3,0,0,1-.41,0l-6.17-6.1A.3.3,0,0,1,237.3,380.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.45,383.65h0a.29.29,0,0,1,.41,0l6.17,6.1a.29.29,0,0,1,0,.41h0a.3.3,0,0,1-.41,0l-6.18-6.1A.3.3,0,0,1,234.45,383.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,371.33l6.13,6.06a.94.94,0,0,1,0,1.32l-29.86,30.21a1,1,0,0,1-1.08.18l16.34-16.53-6.58-6.51,2.75-2.78,6.58,6.51.8-.81-6.58-6.51,2-2.06,6.58,6.5.27-.27-6.58-6.5,2.17-2.21,6.59,6.51.17-.18-6.58-6.51,6.54-6.61A1,1,0,0,1,247.11,371.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.79,371.34l-29.86,30.21a.93.93,0,0,0,0,1.32l6.13,6.06a.81.81,0,0,0,.24.17l.64-.65-6.58-6.51.38-.38,6.58,6.51.93-.94-6.58-6.51.59-.6,6.58,6.51L226.4,405l-6.59-6.51.84-.85,6.59,6.51,1.29-1.31-6.59-6.5.9-.91,6.58,6.51,1.29-1.31-6.58-6.51,1.4-1.41,6.58,6.51.65-.65L226.17,392l2.13-2.16,6.59,6.51.32-.33-6.59-6.5,18.2-18.41A.92.92,0,0,0,245.79,371.34Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08,378.88,226,406.25A37.92,37.92,0,0,1,223.37,394l22.25-22.51a1.18,1.18,0,0,1,1.66,0l5.79,5.73A1.17,1.17,0,0,1,253.08,378.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.71,398.86h-.83s.05,6.69-1.62,10.24l-.51.09H254.32a1.16,1.16,0,0,1-1.17-1.16v-8.15a1.17,1.17,0,0,1,1.17-1.17h.52a1.18,1.18,0,0,1-.67-1v-8.15a1.17,1.17,0,0,1,.67-1.05h-3.25a1.17,1.17,0,0,1-1.17-1.17v-8.15a1.17,1.17,0,0,1,1.17-1.17h2.23a1.18,1.18,0,0,1-.67-1.05v-8.15a1.17,1.17,0,0,1,1.17-1.17h2.93s9.31,3.83,13.1,10.52h-2s3.8,5,3.63,10.22h1.72A23.08,23.08,0,0,1,273.71,398.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,386.78a2.71,2.71,0,0,1,0,.29c0,.28,0,.56,0,.84-.05,1.07-.14,2.12-.29,3.14l-.09.59c0,.08,0,.15,0,.23-.07.39-.14.77-.23,1.15-.15.73-.33,1.43-.54,2.13-.06.19-.12.39-.19.58s-.05.16-.07.23l-.14.38a22.87,22.87,0,0,1-1.07,2.58l-.27.55,0,0-.11.22a21.93,21.93,0,0,1-1.65,2.65c-.14.2-.29.39-.44.58a18.61,18.61,0,0,1-2.38,2.54c-.23.21-.46.4-.7.59a15.3,15.3,0,0,1-2.41,1.57c-.41.22-.83.41-1.26.59A12.87,12.87,0,0,1,241,408h0c-6.57-3-11.29-11.38-11.29-21.18s4.72-18.13,11.29-21.18h0a12,12,0,0,1,1.5-.59,12.62,12.62,0,0,1,4-.65,13,13,0,0,1,4.87,1h0a12.39,12.39,0,0,1,1.17.54l.06,0a14.12,14.12,0,0,1,2.07,1.31l.35.26c.23.18.46.38.69.58h0a18.55,18.55,0,0,1,2.12,2.21l.26.33.44.58c.07.1.15.2.21.3a19.47,19.47,0,0,1,1.17,1.86c.13.23.26.47.38.71s.2.38.29.58c.29.6.56,1.22.81,1.85.17.44.32.89.47,1.34.07.19.13.38.19.58,0,0,0,.06,0,.1.09.3.18.61.26.92.21.81.39,1.64.53,2.49l.09.57h0l.06.46a29.19,29.19,0,0,1,.24,3.53A2.71,2.71,0,0,1,263.26,386.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,386.78a2.71,2.71,0,0,1,0,.29c0,.28,0,.56,0,.84-.05,1.07-.14,2.12-.29,3.14l-.09.59c0,.08,0,.15,0,.23-.07.39-.14.77-.23,1.15-.15.73-.33,1.43-.54,2.13-.06.19-.12.39-.19.58s-.05.16-.07.23l-.14.38a22.87,22.87,0,0,1-1.07,2.58l-.27.55,0,0-.11.22a21.93,21.93,0,0,1-1.65,2.65c-.14.2-.29.39-.44.58a18.61,18.61,0,0,1-2.38,2.54c-.23.21-.46.4-.7.59a15.3,15.3,0,0,1-2.41,1.57c-.41.22-.83.41-1.26.59a13,13,0,0,1-4.88,1H242a1,1,0,0,1-1-.81,1.49,1.49,0,0,1,0-.21v-42.8a1.49,1.49,0,0,1,0-.21v0a1,1,0,0,1,1-.79h4.5a13,13,0,0,1,4.87,1h0a12.39,12.39,0,0,1,1.17.54l.06,0a14.12,14.12,0,0,1,2.07,1.31l.35.26c.23.18.46.38.69.58h0a18.55,18.55,0,0,1,2.12,2.21l.26.33.44.58c.07.1.15.2.21.3a19.47,19.47,0,0,1,1.17,1.86c.13.23.26.47.38.71s.2.38.29.58c.29.6.56,1.22.81,1.85.17.44.32.89.47,1.34.07.19.13.38.19.58,0,0,0,.06,0,.1.09.3.18.61.26.92.21.81.39,1.64.53,2.49l.09.57h0l.06.46a29.19,29.19,0,0,1,.24,3.53A2.71,2.71,0,0,1,263.26,386.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,386.78a2.71,2.71,0,0,1,0,.29h-20.5a.29.29,0,1,1,0-.58h20.5A2.71,2.71,0,0,1,263.26,386.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,365.91h-9.84a.2.2,0,0,1-.13,0,.28.28,0,0,1-.17-.26.3.3,0,0,1,.23-.28h8.68a12.39,12.39,0,0,1,1.17.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,368.06H242.75a.29.29,0,1,1,0-.58H255C255.24,367.66,255.47,367.86,255.7,368.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.53,371.19H242.75a.29.29,0,1,1,0-.58h15.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.58,374.64H242.75a.3.3,0,0,1-.3-.29.29.29,0,0,1,.3-.29h17.54C260.39,374.25,260.49,374.44,260.58,374.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.05,378.41h-19.3a.29.29,0,1,1,0-.58h19.11C261.93,378,262,378.21,262.05,378.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,382.5H242.68a.28.28,0,0,1-.23-.28.3.3,0,0,1,.3-.29h20.11l.09.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6,407.65c-.41.22-.83.41-1.26.59h-8.59a.31.31,0,0,1-.3-.3.3.3,0,0,1,.3-.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.71,405.49c-.23.21-.46.4-.7.59H242.75a.3.3,0,1,1,0-.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.53,402.37c-.14.2-.29.39-.44.58H242.75a.29.29,0,1,1,0-.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.58,398.92l-.27.55,0,0H242.75a.3.3,0,0,1-.3-.29.3.3,0,0,1,.3-.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.05,395.15c-.06.19-.12.39-.19.58H242.75a.29.29,0,1,1,0-.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,391.05l-.09.59H242.75a.31.31,0,0,1-.3-.29.3.3,0,0,1,.3-.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.45,365.33v-.92a5.24,5.24,0,0,1,.7-.05h3.31a13,13,0,0,1,4.87,1h-8.88Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,367.22H242.45v-1.35h10.08l.06,0A14.12,14.12,0,0,1,254.66,367.22Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83,370.28H242.45v-2.21h13.26A18.55,18.55,0,0,1,257.83,370.28Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.91,373.35H242.45v-1.86h16.29A19.47,19.47,0,0,1,259.91,373.35Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,376.49H242.45v-1.85h18.13C260.87,375.24,261.14,375.86,261.39,376.49Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.33,379.43H242.45v-.92h19.62C262.16,378.81,262.25,379.12,262.33,379.43Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,383H242.45v-.47H263Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,389.25l0-.33c0-.32,0-.64.05-1v0h0c0-.37,0-.75,0-1.13,0-12.38-7.52-22.42-16.8-22.42h-.35c9.12.24,16.45,10.19,16.45,22.41,0,.38,0,.76,0,1.13H242.45v-23.5c-.76.11-1.34.39-1.48.74v0a.34.34,0,0,0,0,.14v42.94a.34.34,0,0,0,0,.14c.15.46,1.07.81,2.18.81h3.31c.26,0,.52,0,.77,0l.23,0,.58,0,.21,0,.74-.13.14,0,.6-.14.24-.07.56-.17.17-.06.64-.23.06,0,.23-.1.49-.22.25-.12.23-.12c.09,0,.18-.1.27-.15l.21-.12.52-.31.18-.11q.33-.21.66-.45l.21-.16.36-.27.06-.05.48-.4.16-.14,0,0,.34-.32.33-.31.26-.26c.13-.13.25-.26.37-.4l.23-.25c.13-.14.26-.29.38-.44l.19-.24a3.11,3.11,0,0,0,.23-.28l.17-.22c.06-.07.11-.15.17-.23a1.47,1.47,0,0,1,.1-.13c.07-.1.14-.21.22-.31l.18-.26.49-.75,0-.06c.15-.24.29-.49.43-.74l.09-.16.21-.37h0c0-.08.09-.16.13-.25h0a.08.08,0,0,1,0,0l.13-.27.12-.24a1.42,1.42,0,0,0,.08-.18c.14-.29.27-.59.4-.89l.12-.27c.16-.4.32-.8.46-1.21v0h0c.05-.12.09-.25.13-.38h0c0-.07,0-.15.07-.23l0-.1c0-.1.07-.2.1-.3l.06-.18.06-.25.18-.62.12-.46c.06-.23.11-.47.16-.7a.44.44,0,0,0,0-.1h0c.08-.38.16-.76.23-1.15h0c0-.08,0-.15,0-.23s0-.16,0-.23l0-.21c0-.05,0-.1,0-.15,0-.27.08-.54.11-.81,0-.07,0-.14,0-.21C263.11,389.77,263.13,389.51,263.15,389.25Zm-3.67,10.47h-17v-.25h17.16C259.57,399.56,259.52,399.64,259.48,399.72Zm1.48-3.38H242.45V396h18.64C261.05,396.09,261,396.22,261,396.34Zm.94-3.32H242.45v-1.15h19.67C262.06,392.26,262,392.64,261.9,393Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,386.78c0,12.38-7.52,22.42-16.8,22.42s-16.8-10-16.8-22.42,7.52-22.42,16.8-22.42S258.75,374.4,258.75,386.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.95,
    cy: 386.78,
    rx: 14.1,
    ry: 18.82,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,381.33h0c-1.83-9.75-8.43-17-16.3-17-9.28,0-16.8,10-16.8,22.42A28.3,28.3,0,0,0,227.39,398c2.9,6.71,8.34,11.24,14.56,11.24,9.28,0,16.8-10,16.8-22.42A29.38,29.38,0,0,0,258.25,381.33ZM242,408.45c-5.54,0-10.44-3.71-13.36-9.37a26.85,26.85,0,0,1-2.87-12.3c0-12,7.27-21.67,16.23-21.67,8.07,0,14.76,7.85,16,18.14a29.22,29.22,0,0,1,.22,3.53C258.19,398.74,250.92,408.45,242,408.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7,378.73c-2.35-6-7.07-10.13-12.51-10.13-7.79,0-14.1,8.43-14.1,18.82a24.14,24.14,0,0,0,1.36,8.07,23.93,23.93,0,0,1-1.6-8.71c0-10.39,6.31-18.82,14.1-18.82C247.58,368,252.44,372.36,254.7,378.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,386.78c0,12.38-7.52,22.42-16.8,22.42-6.22,0-11.66-4.53-14.56-11.24.37.36.77.73,1.2,1.12,2.92,5.66,7.82,9.37,13.36,9.37,9,0,16.24-9.71,16.24-21.67a29.22,29.22,0,0,0-.22-3.53c.11-.68.2-1.32.28-1.92A29.38,29.38,0,0,1,258.75,386.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.17,396.94V400h-1.69l-.48-.64.48-2.41a9.66,9.66,0,0,1-5.52-2.92l1.4-2.14a6.91,6.91,0,0,0,4.12,2.09v-5.5c-1.36-.44-3.92-1.72-4.56-3.33a9.78,9.78,0,0,1-.18-2.22c0-2.81,1.53-5.25,4.74-5.67l1.21-3.74.48.64v3.05a16.06,16.06,0,0,1,3.7,1l.48.64-.84,2.77a7.19,7.19,0,0,0-3.34-1.48v5.55a24.12,24.12,0,0,1,3.22,1.44,6.44,6.44,0,0,1,1.56,4.09A5.33,5.33,0,0,1,243.17,396.94Zm-1.69-11.77v-4.89a2.38,2.38,0,0,0-2.08,2.5C239.4,384.1,240.29,384.71,241.48,385.17Zm3.83,6.35c0-1.34-.9-2-2.14-2.44v4.86A2.34,2.34,0,0,0,245.31,391.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M242.69,396.3v3.08H241v-3.05a7.75,7.75,0,0,1-5-2.28l.92-2.78a6.91,6.91,0,0,0,4.12,2.09v-5.5c-2.28-.74-4.74-1.73-4.74-5.55,0-2.81,1.53-5.25,4.74-5.66v-3.11h1.69v3a7.33,7.33,0,0,1,4.18,1.68L246,381a7.15,7.15,0,0,0-3.34-1.48v5.55c2.29.75,4.78,1.71,4.78,5.53A5.33,5.33,0,0,1,242.69,396.3ZM241,384.54v-4.9a2.38,2.38,0,0,0-2.08,2.5C238.92,383.46,239.81,384.07,241,384.54Zm3.83,6.35c0-1.35-.9-2-2.14-2.45v4.86A2.34,2.34,0,0,0,244.83,390.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,386.78c0,7.76-3,14.61-7.46,18.63l-24.57-28.08c2.67-7.66,8.49-13,15.23-13C251.23,364.36,258.75,374.4,258.75,386.78Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.71,
    y: 320.19,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    transform: "translate(90.42 -64.85) rotate(14.4)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.73,329.89h0a.28.28,0,0,1-.2-.35l2.16-8.41a.3.3,0,0,1,.35-.21h0a.3.3,0,0,1,.21.36l-2.16,8.4A.29.29,0,0,1,300.73,329.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.46,324.69h0a.29.29,0,0,1-.2-.35l2.15-8.41a.29.29,0,0,1,.36-.21h0a.29.29,0,0,1,.2.35l-2.15,8.41A.3.3,0,0,1,280.46,324.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.53,325.22h0a.29.29,0,0,1-.21-.35l2.16-8.41a.29.29,0,0,1,.35-.21h0a.29.29,0,0,1,.21.35L282.88,325A.29.29,0,0,1,282.53,325.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,326h0a.29.29,0,0,1-.2-.35l2.15-8.41a.29.29,0,0,1,.36-.21h0a.29.29,0,0,1,.2.35l-2.15,8.41A.3.3,0,0,1,285.52,326Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,326.84h0a.29.29,0,0,1-.21-.36l2.16-8.4a.29.29,0,0,1,.35-.21h0a.29.29,0,0,1,.21.35l-2.16,8.41A.29.29,0,0,1,288.83,326.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.44,327.76h0a.29.29,0,0,1-.21-.35l2.16-8.41a.29.29,0,0,1,.35-.2h0a.28.28,0,0,1,.21.35l-2.16,8.4A.29.29,0,0,1,292.44,327.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36,328.77h0a.29.29,0,0,1-.21-.35l2.16-8.41a.3.3,0,0,1,.36-.21h0a.29.29,0,0,1,.2.35l-2.16,8.41A.28.28,0,0,1,296.36,328.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.31,326.13h0a.29.29,0,0,1,.21.35l-2.16,8.41a.29.29,0,0,1-.35.21h0a.29.29,0,0,1-.21-.35l2.16-8.41A.28.28,0,0,1,323.31,326.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.24,325.6h0a.29.29,0,0,1,.21.35l-2.16,8.41a.29.29,0,0,1-.35.21h0a.29.29,0,0,1-.21-.35l2.16-8.41A.29.29,0,0,1,321.24,325.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.25,324.83h0a.29.29,0,0,1,.21.35l-2.16,8.41a.29.29,0,0,1-.35.21h0a.29.29,0,0,1-.21-.35L317.9,325A.28.28,0,0,1,318.25,324.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.94,324h0a.29.29,0,0,1,.21.35L313,332.74a.28.28,0,0,1-.35.21h0a.29.29,0,0,1-.21-.35l2.16-8.41A.29.29,0,0,1,314.94,324Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.33,323.05h0a.29.29,0,0,1,.21.36l-2.16,8.4a.29.29,0,0,1-.35.21h0a.28.28,0,0,1-.21-.35l2.16-8.41A.29.29,0,0,1,311.33,323.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.41,322.05h0a.29.29,0,0,1,.21.35l-2.16,8.41a.29.29,0,0,1-.35.21h0a.29.29,0,0,1-.21-.36l2.16-8.4A.29.29,0,0,1,307.41,322.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42,326.77l-2.14,8.35a.93.93,0,0,1-1.14.67L280,325.23a.92.92,0,0,1-.7-.84l22.51,5.78,2.3-9,3.79,1-2.3,9,1.1.29,2.3-9,2.82.72-2.3,9,.36.09,2.31-9,3,.77-2.3,9,.25.07,2.3-9,9,2.31A1,1,0,0,1,324.42,326.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.75,325.64l-41.13-10.57a.93.93,0,0,0-1.14.67l-2.14,8.35a.77.77,0,0,0,0,.3l.88.23,2.31-9,.52.13-2.31,9,1.29.33,2.3-9,.81.21-2.3,9,2.13.55,2.3-9,1.16.3-2.3,9,1.77.46,2.3-9,1.24.32-2.3,9,1.77.45,2.3-9,1.93.49-2.3,9,.89.23,2.3-9,2.93.75-2.3,9,.45.11,2.3-9,25.07,6.43A.93.93,0,0,0,323.75,325.64Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.79,
    y: 398.71,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,309,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,288,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.16,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,290.16,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.25,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,293.25,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,296.66,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,300.39,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.44,408.56h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,304.44,408.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.88,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,329.88,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,327.75,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,324.66,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,399.3h0a.28.28,0,0,1,.28.29v8.68a.28.28,0,0,1-.28.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,321.25,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.52,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,317.52,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.47,399.3h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,313.47,399.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.12,399.64v8.62a.94.94,0,0,1-.93.94H287.72a.93.93,0,0,1-.89-.64h23.24V399.3H314v9.26h1.13V399.3H318v9.26h.38V399.3h3.09v9.26h.26V399.3h9.3A1,1,0,0,1,331.12,399.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.19,398.71H287.72a.94.94,0,0,0-.94.93v8.62a.94.94,0,0,0,.05.3h.91V399.3h.54v9.26h1.33V399.3h.84v9.26h2.19V399.3h1.2v9.26h1.83V399.3H297v9.26h1.83V399.3h2v9.26h.92V399.3h3v9.26h.46V399.3h25.88A.94.94,0,0,0,330.19,398.71Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.03,
    y: 388.21,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,398.06h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,305.2,398.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.27,398.06h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,284.27,398.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.41,398.06h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.28.28,0,0,1,.28.29v8.68A.28.28,0,0,1,286.41,398.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5,398.06h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,289.5,398.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.91,398.06h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,292.91,398.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.64,398.06h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,296.64,398.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.69,398.06h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,300.69,398.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13,388.8h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,326.13,388.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,388.8h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,324,388.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.91,388.8h0a.28.28,0,0,1,.28.29v8.68a.28.28,0,0,1-.28.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,320.91,388.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.49,388.8h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.28-.29v-8.68A.29.29,0,0,1,317.49,388.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.76,388.8h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.28-.29v-8.68A.29.29,0,0,1,313.76,388.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.72,388.8h0a.28.28,0,0,1,.28.29v8.68a.28.28,0,0,1-.28.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,309.72,388.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37,389.14v8.62a.93.93,0,0,1-.93.93H284a.92.92,0,0,1-.89-.63h23.24V388.8h3.92v9.26h1.13V388.8h2.91v9.26h.38V388.8h3.09v9.26H318V388.8h9.31A.93.93,0,0,1,327.37,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.44,388.21H284a.93.93,0,0,0-.94.93v8.62a1,1,0,0,0,.05.3H284V388.8h.54v9.26h1.33V388.8h.84v9.26h2.19V388.8h1.2v9.26h1.83V388.8h1.28v9.26H295V388.8h2v9.26h.92V388.8h3v9.26h.46V388.8h25.88A.94.94,0,0,0,326.44,388.21Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.13,
    y: 377.7,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,387.55h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,309.29,387.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.36,387.55h0a.28.28,0,0,1-.28-.29v-8.68a.28.28,0,0,1,.28-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,288.36,387.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.21,
    y: 378.29,
    width: 0.58,
    height: 9.26,
    rx: 0.29,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,387.55h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,293.59,387.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,387.55h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,297,387.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.73,387.55h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,300.73,387.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.78,387.55h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,304.78,387.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,378.29h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,330.22,378.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,378.29h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,328.09,378.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,378.29h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,325,378.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.59,378.29h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,321.59,378.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.86,378.29h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,317.86,378.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,378.29h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,313.81,378.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,378.64v8.62a.93.93,0,0,1-.93.93H288.06a.94.94,0,0,1-.89-.64h23.24v-9.26h3.92v9.26h1.13v-9.26h2.91v9.26h.38v-9.26h3.09v9.26h.26v-9.26h9.3A1,1,0,0,1,331.46,378.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,377.7H288.06a.93.93,0,0,0-.93.94v8.62a.92.92,0,0,0,0,.29h.92v-9.26h.53v9.26H290v-9.26h.84v9.26H293v-9.26h1.2v9.26H296v-9.26h1.28v9.26h1.83v-9.26h2v9.26H302v-9.26h3v9.26h.46v-9.26H331.4A1,1,0,0,0,330.53,377.7Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.13,
    y: 367.2,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,377.05h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,309.29,377.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.36,377.05h0a.28.28,0,0,1-.28-.29v-8.68a.28.28,0,0,1,.28-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,288.36,377.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.21,
    y: 367.79,
    width: 0.58,
    height: 9.26,
    rx: 0.29,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,377.05h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,293.59,377.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,377.05h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,297,377.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.73,377.05h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,300.73,377.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.78,377.05h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,304.78,377.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,367.79h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,330.22,367.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,367.79h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,328.09,367.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,367.79h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,325,367.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.59,367.79h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,321.59,367.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.86,367.79h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,317.86,367.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,367.79h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,313.81,367.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,368.13v8.62a.94.94,0,0,1-.93.94H288.06a.94.94,0,0,1-.89-.64h23.24v-9.26h3.92v9.26h1.13v-9.26h2.91v9.26h.38v-9.26h3.09v9.26h.26v-9.26h9.3A1,1,0,0,1,331.46,368.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,367.2H288.06a.93.93,0,0,0-.93.93v8.62a1,1,0,0,0,0,.3h.92v-9.26h.53v9.26H290v-9.26h.84v9.26H293v-9.26h1.2v9.26H296v-9.26h1.28v9.26h1.83v-9.26h2v9.26H302v-9.26h3v9.26h.46v-9.26H331.4A.94.94,0,0,0,330.53,367.2Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 356.7,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25,366.54h0a.28.28,0,0,1-.29-.28v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.28.28,0,0,1,307.25,366.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,366.54h0a.28.28,0,0,1-.29-.28v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.28.28,0,0,1,286.32,366.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.45,366.54h0a.28.28,0,0,1-.29-.28v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.28.28,0,0,1,288.45,366.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.54,366.54h0a.28.28,0,0,1-.29-.28v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.28.28,0,0,1,291.54,366.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,366.54h0a.28.28,0,0,1-.29-.28v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.28.28,0,0,1,295,366.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.68,366.54h0a.28.28,0,0,1-.29-.28v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.28.28,0,0,1,298.68,366.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.73,366.54h0a.28.28,0,0,1-.29-.28v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.28.28,0,0,1,302.73,366.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.18,357.29h0a.29.29,0,0,1,.29.29v8.68a.28.28,0,0,1-.29.28h0a.28.28,0,0,1-.29-.28v-8.68A.29.29,0,0,1,328.18,357.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,357.29h0a.29.29,0,0,1,.29.29v8.68a.28.28,0,0,1-.29.28h0a.28.28,0,0,1-.29-.28v-8.68A.29.29,0,0,1,326,357.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,357.29h0a.29.29,0,0,1,.29.29v8.68a.28.28,0,0,1-.29.28h0a.28.28,0,0,1-.29-.28v-8.68A.29.29,0,0,1,323,357.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.54,357.29h0a.29.29,0,0,1,.29.29v8.68a.28.28,0,0,1-.29.28h0a.28.28,0,0,1-.29-.28v-8.68A.29.29,0,0,1,319.54,357.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.81,357.29h0a.29.29,0,0,1,.29.29v8.68a.28.28,0,0,1-.29.28h0a.28.28,0,0,1-.29-.28v-8.68A.29.29,0,0,1,315.81,357.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76,357.29h0a.29.29,0,0,1,.29.29v8.68a.28.28,0,0,1-.29.28h0a.28.28,0,0,1-.29-.28v-8.68A.29.29,0,0,1,311.76,357.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,357.63v8.62a.94.94,0,0,1-.94.93H286a.93.93,0,0,1-.88-.64h23.24v-9.25h3.91v9.25h1.14v-9.25h2.9v9.25h.38v-9.25h3.1v9.25h.25v-9.25h9.3A.94.94,0,0,1,329.42,357.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.48,356.7H286a.93.93,0,0,0-.93.93v8.62a.93.93,0,0,0,.05.29H286v-9.25h.54v9.25h1.32v-9.25h.84v9.25h2.2v-9.25h1.19v9.25H294v-9.25h1.27v9.25h1.84v-9.25h2v9.25H300v-9.25h3v9.25h.46v-9.25h25.88A.93.93,0,0,0,328.48,356.7Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.13,
    y: 346.19,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,356h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,309.29,356Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.36,356h0a.28.28,0,0,1-.28-.29v-8.68a.28.28,0,0,1,.28-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,288.36,356Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.21,
    y: 346.78,
    width: 0.58,
    height: 9.26,
    rx: 0.29,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,356h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,293.59,356Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,356h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,297,356Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.73,356h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,300.73,356Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.78,356h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,304.78,356Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,346.78h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,330.22,346.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,346.78h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,328.09,346.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,346.78h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,325,346.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.59,346.78h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,321.59,346.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.86,346.78h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,317.86,346.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,346.78h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,313.81,346.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,347.13v8.62a.93.93,0,0,1-.93.93H288.06a.94.94,0,0,1-.89-.64h23.24v-9.26h3.92V356h1.13v-9.26h2.91V356h.38v-9.26h3.09V356h.26v-9.26h9.3A1,1,0,0,1,331.46,347.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,346.19H288.06a.93.93,0,0,0-.93.94v8.62a.92.92,0,0,0,0,.29h.92v-9.26h.53V356H290v-9.26h.84V356H293v-9.26h1.2V356H296v-9.26h1.28V356h1.83v-9.26h2V356H302v-9.26h3V356h.46v-9.26H331.4A1,1,0,0,0,330.53,346.19Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 335.69,
    width: 44.33,
    height: 10.49,
    rx: 1.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25,345.54h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,307.25,345.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,345.54h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,286.32,345.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.45,345.54h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,288.45,345.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.54,345.54h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,291.54,345.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,345.54h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,295,345.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.68,345.54h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,298.68,345.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.73,345.54h0a.29.29,0,0,1-.29-.29v-8.68a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v8.68A.29.29,0,0,1,302.73,345.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.18,336.28h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,328.18,336.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,336.28h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,326,336.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,336.28h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,323,336.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.54,336.28h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,319.54,336.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.81,336.28h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,315.81,336.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76,336.28h0a.29.29,0,0,1,.29.29v8.68a.29.29,0,0,1-.29.29h0a.29.29,0,0,1-.29-.29v-8.68A.29.29,0,0,1,311.76,336.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,336.62v8.62a.94.94,0,0,1-.94.94H286a.93.93,0,0,1-.88-.64h23.24v-9.26h3.91v9.26h1.14v-9.26h2.9v9.26h.38v-9.26h3.1v9.26h.25v-9.26h9.3A1,1,0,0,1,329.42,336.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.48,335.69H286a.93.93,0,0,0-.93.93v8.62a1,1,0,0,0,.05.3H286v-9.26h.54v9.26h1.32v-9.26h.84v9.26h2.2v-9.26h1.19v9.26H294v-9.26h1.27v9.26h1.84v-9.26h2v9.26H300v-9.26h3v9.26h.46v-9.26h25.88A.93.93,0,0,0,328.48,335.69Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,367.2h1.2l-1.77.15A1.21,1.21,0,0,1,288.3,367.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.26,329.14l-15-3.85a1.18,1.18,0,0,1-.84-1.43l.62-2.42a21.54,21.54,0,0,1,5.78,1A17.22,17.22,0,0,1,295.26,329.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25,356.69H297.5a35.63,35.63,0,0,1-7.71,10.48h-3.54a1.17,1.17,0,0,1-1.17-1.17v-8.14A1.17,1.17,0,0,1,286.25,356.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,346.19h14.56c-.11.46-1.79,7.24-4.46,10.49H288.3a1.18,1.18,0,0,1-1.18-1.17v-8.15A1.18,1.18,0,0,1,288.3,346.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.34,346.17H286.25a1.17,1.17,0,0,1-1.17-1.17v-8.14a1.17,1.17,0,0,1,1.17-1.17h16.58C302.94,338.15,302.91,342.82,301.34,346.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.2,398.69H287.58c6.36-2.43,15.78-6.33,22.6-10.48h16a1.17,1.17,0,0,1,1.17,1.17v8.14A1.17,1.17,0,0,1,326.2,398.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.12,399.88v6.63a19.44,19.44,0,0,1-6.12-4.4,39.26,39.26,0,0,1-22.73,7.07,33.71,33.71,0,0,1-15.49-3.7v-5.6a1.17,1.17,0,0,1,1.18-1.17h42A1.17,1.17,0,0,1,331.12,399.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,368.37v8.14a1.17,1.17,0,0,1-1.17,1.18h-11.2c1.63-7.64,5.91-10.25,5.91-10.25h5.54l.61.14A1.16,1.16,0,0,1,331.46,368.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,378.88V387a1.17,1.17,0,0,1-1.17,1.17H310.2c4.71-2.86,8.18-5.85,8.55-8.55.09-.68.2-1.32.34-1.94h11.2A1.17,1.17,0,0,1,331.46,378.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.73,354.57l-.14.25c-.13.25-.26.49-.4.72a29.85,29.85,0,0,1-1.7,2.6c-.11.16-.23.31-.35.46l-.14.19c-.24.3-.48.6-.73.89-.47.56-.95,1.09-1.46,1.59-.14.15-.28.29-.43.43l-.17.16-.29.27a26,26,0,0,1-2.12,1.74l-.5.35,0,0-.21.14a20.85,20.85,0,0,1-2.65,1.53l-.65.31a19,19,0,0,1-3.24,1.1c-.29.07-.58.13-.88.18a15,15,0,0,1-2.82.26c-.46,0-.91,0-1.36-.08a12.77,12.77,0,0,1-4.68-1.42,13,13,0,0,1-4.21-3.62h0c-4.29-5.68-4.53-15.08,0-23.59s12.47-13.56,19.58-13.16h0a13.63,13.63,0,0,1,1.58.18,12.52,12.52,0,0,1,7.56,4.38l0,0c.27.32.53.66.77,1l0,.06a15.73,15.73,0,0,1,1.19,2.09c.06.13.12.26.17.39s.23.54.34.83h0a18.38,18.38,0,0,1,.82,2.91c0,.13.05.26.07.4l.12.71c0,.12,0,.24,0,.36a21.52,21.52,0,0,1,.16,2.15v.79c0,.21,0,.42,0,.64,0,.65-.08,1.31-.16,2-.05.46-.12.92-.2,1.38,0,.19-.07.39-.11.59a.3.3,0,0,0,0,.1c-.06.3-.13.61-.21.92q-.29,1.2-.69,2.4c-.06.18-.12.36-.19.54h0c-.05.14-.1.28-.16.42a27.88,27.88,0,0,1-1.42,3.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.73,354.57l-.14.25c-.13.25-.26.49-.4.72a29.85,29.85,0,0,1-1.7,2.6c-.11.16-.23.31-.35.46l-.14.19c-.24.3-.48.6-.73.89-.47.56-.95,1.09-1.46,1.59-.14.15-.28.29-.43.43l-.17.16-.29.27a26,26,0,0,1-2.12,1.74l-.5.35,0,0-.21.14a20.85,20.85,0,0,1-2.65,1.53l-.65.31a19,19,0,0,1-3.24,1.1c-.29.07-.58.13-.88.18a15,15,0,0,1-2.82.26c-.46,0-.91,0-1.36-.08a12.77,12.77,0,0,1-4.68-1.42l-3.9-2.08a1,1,0,0,1-.49-1.16,1.08,1.08,0,0,1,.08-.19l19.79-37.15a.91.91,0,0,1,.11-.16v0a1,1,0,0,1,1.23-.23l3.9,2.08a12.89,12.89,0,0,1,3.78,3.09l0,0c.27.32.53.66.77,1l0,.06a15.73,15.73,0,0,1,1.19,2.09c.06.13.12.26.17.39s.23.54.34.83h0a18.38,18.38,0,0,1,.82,2.91c0,.13.05.26.07.4l.12.71c0,.12,0,.24,0,.36a21.52,21.52,0,0,1,.16,2.15v.79c0,.21,0,.42,0,.64,0,.65-.08,1.31-.16,2-.05.46-.12.92-.2,1.38,0,.19-.07.39-.11.59a.3.3,0,0,0,0,.1c-.06.3-.13.61-.21.92q-.29,1.2-.69,2.4c-.06.18-.12.36-.19.54h0c-.05.14-.1.28-.16.42a27.88,27.88,0,0,1-1.42,3.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.73,354.57l-.14.25-17.79-9.48a.28.28,0,0,1-.12-.39.29.29,0,0,1,.39-.12l17.79,9.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.13,331.53,285.58,327a.2.2,0,0,1-.09-.09.27.27,0,0,1,0-.3.29.29,0,0,1,.33-.14l.06,0,7.45,4,0,0c.27.32.53.66.77,1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.83,334.84l-11.24-6a.29.29,0,0,1,.26-.51L295.49,334C295.61,334.28,295.72,334.55,295.83,334.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.84,338.86l-13.7-7.3a.29.29,0,0,1,.27-.51l13.31,7.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,342.8l-15.47-8.25a.27.27,0,0,1-.12-.38.27.27,0,0,1,.38-.12L297,342.16C297,342.37,297,342.58,297,342.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.55,346.75l-16.75-8.92a.29.29,0,0,1,.27-.51l16.59,8.84C296.62,346.35,296.59,346.55,296.55,346.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.44,350.72l-17.53-9.34-.06,0a.3.3,0,0,1-.06-.35.29.29,0,0,1,.39-.12l17.45,9.3c-.06.18-.12.36-.19.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.83,367.76c-.46,0-.91,0-1.36-.08l-7.46-4a.29.29,0,0,1,.27-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.53,367.32c-.29.07-.58.13-.88.18L267,361.83a.28.28,0,0,1-.12-.38.29.29,0,0,1,.39-.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.42,365.91l-.65.31-13.32-7.1a.29.29,0,0,1-.11-.39.29.29,0,0,1,.39-.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.8,363.87l-.5.35,0,0-15.23-8.11a.28.28,0,0,1-.1-.09.29.29,0,0,1,0-.3.3.3,0,0,1,.39-.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.81,361.27c-.14.15-.28.29-.43.43l-16.59-8.84a.29.29,0,0,1,.27-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,358.14c-.11.16-.23.31-.35.46l-17.45-9.3a.27.27,0,0,1-.12-.38.29.29,0,0,1,.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.59,326.34l.43-.8a5.78,5.78,0,0,1,.63.28l2.87,1.53a12.89,12.89,0,0,1,3.78,3.09l0,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.32,333.62,284.72,328l.62-1.17,8.75,4.66,0,.06A15.73,15.73,0,0,1,295.32,333.62Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.65,337.75l-13.34-7.11,1-1.92,11.5,6.12A18.38,18.38,0,0,1,296.65,337.75Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,341.37l-15.15-8.07.86-1.61,14.13,7.53A21.52,21.52,0,0,1,297,341.37Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.86,344.78,280.43,336l.86-1.61L297,342.8C297,343.45,296.94,344.11,296.86,344.78Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,347.77l-17.24-9.19.42-.81,17,9.08C296.47,347.15,296.4,347.46,296.32,347.77Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.28,351.14l-17.83-9.5.21-.4,17.78,9.47h0C295.39,350.86,295.34,351,295.28,351.14Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5,356.67l.18-.28.48-.8,0,0v0h0c.18-.31.36-.64.54-1,5.72-10.74,3.84-22.93-4.21-27.22l-.3-.15c7.79,4.43,9.56,16.45,3.91,27.05l-.54,1-17.43-9.28L286,325.54a1.84,1.84,0,0,0-1.63,0v0a.39.39,0,0,0-.08.1l-19.86,37.27a.5.5,0,0,0,0,.13c-.08.47.56,1.19,1.52,1.71l2.87,1.53q.34.18.69.33l.2.09.53.22.19.07c.23.09.47.17.7.24l.14,0,.59.15.23.05.57.11.18,0q.33.06.66.09h.31l.53,0h1.07l.59,0,.21,0,.78-.09.25,0,.44-.07h.07l.61-.13.2,0,.06,0,.45-.11.42-.12.35-.11.51-.17.31-.11.54-.21.27-.12.33-.13.25-.12.26-.12.14-.07.33-.17.28-.14c.26-.13.52-.28.77-.42l.05,0c.25-.14.49-.28.72-.44l.16-.09.34-.23h0a1.88,1.88,0,0,1,.23-.16h0l0,0,.24-.17.22-.15.15-.12.76-.58.22-.19c.33-.26.65-.54,1-.83l0,0h0l.29-.28h0l.17-.16.08-.08.22-.21.13-.14.17-.18.44-.45c.11-.12.21-.24.32-.35l.47-.54.06-.07h0c.25-.29.49-.59.73-.9h0l.14-.19.14-.18.12-.17.09-.11.47-.66a1,1,0,0,0,.11-.17C292.22,357.1,292.36,356.88,292.5,356.67Zm-8,7.39-14.77-7.87.12-.22,14.89,7.93Zm2.86-2.25-16.06-8.56.18-.33,16.17,8.61Zm2.35-2.45-16.88-9,.54-1,17.06,9.09C290.16,358.77,289.91,359.07,289.67,359.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.82,352.49c-5.73,10.74-16.89,16-24.94,11.68s-9.94-16.47-4.21-27.21,16.89-16,24.94-11.69S295.54,341.75,289.82,352.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.48,351.24c4.8-9,3.22-19.25-3.54-22.85s-16.13.8-20.93,9.81-3.22,19.25,3.53,22.85S282.67,360.26,287.48,351.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.91,347.53h0c2.92-9.3.53-18.61-6.3-22.25-8.05-4.29-19.22.94-24.94,11.69a27.85,27.85,0,0,0-3.23,10.73c-.59,7.17,2,13.6,7.44,16.48,8.05,4.29,19.22-.94,24.94-11.68A29.77,29.77,0,0,0,291.91,347.53Zm-26.68,16c-4.81-2.56-7.34-8-7.27-14.31a26.46,26.46,0,0,1,3.2-12c5.53-10.38,16.32-15.44,24.1-11.3,7,3.73,9.18,13.63,5.52,23.14a28.84,28.84,0,0,1-1.45,3.17C283.8,362.61,273,367.67,265.23,363.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,343.63c.74-6.31-1.46-12.06-6.18-14.57-6.75-3.6-16.13.79-20.93,9.81a23.61,23.61,0,0,0-2.55,7.63,23.66,23.66,0,0,1,2.64-8.3c4.8-9,14.17-13.41,20.93-9.81C288.83,331,291,337.06,290,343.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.82,352.49c-5.72,10.74-16.89,16-24.94,11.68-5.4-2.88-8-9.31-7.44-16.48.15.48.32,1,.52,1.52-.07,6.27,2.46,11.75,7.27,14.31,7.78,4.15,18.57-.91,24.1-11.29a28.84,28.84,0,0,0,1.45-3.17c.41-.54.78-1.05,1.13-1.53A29.77,29.77,0,0,1,289.82,352.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.12,354.78l-.76,3-1.66,0-.32-.62,1.07-2.32a7.06,7.06,0,0,1-4.71-2.87l1.91-2.06a5.06,5.06,0,0,0,3.53,2.06l1.36-5.31c-1.23-.44-3.43-1.7-3.66-3.25a9.45,9.45,0,0,1,.37-2.15,7,7,0,0,1,6.06-5.43l2.11-3.6.31.62-.75,2.95a13.21,13.21,0,0,1,3.38,1l.32.63-1.52,2.67a5.44,5.44,0,0,0-2.91-1.47L275.88,344a18.24,18.24,0,0,1,2.81,1.42,5.18,5.18,0,0,1,.52,4A7.08,7.08,0,0,1,273.12,354.78Zm1.24-11.38,1.21-4.72a3.18,3.18,0,0,0-2.67,2.39C272.58,342.35,273.3,342.94,274.36,343.4Zm2.2,6.17c.33-1.3-.4-1.92-1.5-2.38l-1.2,4.69A3.1,3.1,0,0,0,276.56,349.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,354.15l-.76,3-1.66,0,.76-2.94a5.83,5.83,0,0,1-4.4-2.25l1.59-2.68a5.14,5.14,0,0,0,3.54,2.06l1.36-5.31c-2.07-.74-4.23-1.72-3.29-5.4a7,7,0,0,1,6.05-5.43l.77-3,1.66,0-.75,2.95a5.66,5.66,0,0,1,3.69,1.65l-1.51,2.68a5.37,5.37,0,0,0-2.92-1.47l-1.37,5.36c2.07.74,4.28,1.69,3.34,5.38A7.05,7.05,0,0,1,272.8,354.15Zm1.25-11.37,1.2-4.72a3.15,3.15,0,0,0-2.66,2.39C272.27,341.73,273,342.32,274.05,342.78Zm2.2,6.17c.33-1.3-.41-1.92-1.51-2.39l-1.2,4.7A3.13,3.13,0,0,0,276.25,349Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.82,352.49c-5.73,10.74-16.89,16-24.94,11.68s-9.94-16.47-4.21-27.21,16.89-16,24.94-11.69S295.54,341.75,289.82,352.49Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,395.12c.05.09.09.18.14.26.12.26.25.51.38.75a30.29,30.29,0,0,0,1.64,2.7l.34.48.13.2c.24.31.47.63.72.93.45.58.93,1.14,1.42,1.67l.43.45.17.17.28.28a25.74,25.74,0,0,0,2.1,1.85l.49.37,0,0,.2.15a21.8,21.8,0,0,0,2.64,1.65l.65.34a19.36,19.36,0,0,0,3.26,1.23c.3.08.59.16.89.22a14.8,14.8,0,0,0,2.86.35c.47,0,.93,0,1.39,0a12.86,12.86,0,0,0,9.22-4.82h0c4.56-5.63,5.13-15.19.82-24S343,366.11,335.73,366.27h0a12.34,12.34,0,0,0-1.61.13,12.59,12.59,0,0,0-3.89,1.18,13,13,0,0,0-4,3l0,0c-.29.32-.56.65-.82,1l0,.06a14.24,14.24,0,0,0-1.28,2.09c-.07.12-.13.25-.19.38a8.75,8.75,0,0,0-.37.83h0a19.63,19.63,0,0,0-.93,2.93l-.09.4c0,.24-.1.48-.14.72l-.06.37c-.11.71-.19,1.44-.23,2.18l0,.8c0,.22,0,.43,0,.65,0,.67,0,1.34.09,2,0,.46.09.93.16,1.4l.09.61a.44.44,0,0,0,0,.1c.05.31.11.63.17.94.17.82.38,1.65.62,2.47l.18.56s0,0,0,0,.09.29.14.43a31.4,31.4,0,0,0,1.34,3.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,395.12c.05.09.09.18.14.26.12.26.25.51.38.75a30.29,30.29,0,0,0,1.64,2.7l.34.48.13.2c.24.31.47.63.72.93.45.58.93,1.14,1.42,1.67l.43.45.17.17.28.28a25.74,25.74,0,0,0,2.1,1.85l.49.37,0,0,.2.15a21.8,21.8,0,0,0,2.64,1.65l.65.34a19.36,19.36,0,0,0,3.26,1.23c.3.08.59.16.89.22a14.8,14.8,0,0,0,2.86.35c.47,0,.93,0,1.39,0a13.17,13.17,0,0,0,4.81-1.28l4-2a1,1,0,0,0,.54-1.17,1.46,1.46,0,0,0-.07-.19l-18.85-38.47a.54.54,0,0,0-.11-.18v0a1,1,0,0,0-1.23-.27l-4,2a13,13,0,0,0-4,3l0,0c-.29.32-.56.65-.82,1l0,.06a14.24,14.24,0,0,0-1.28,2.09c-.07.12-.13.25-.19.38a8.75,8.75,0,0,0-.37.83h0a19.63,19.63,0,0,0-.93,2.93l-.09.4c0,.24-.1.48-.14.72l-.06.37c-.11.71-.19,1.44-.23,2.18l0,.8c0,.22,0,.43,0,.65,0,.67,0,1.34.09,2,0,.46.09.93.16,1.4l.09.61a.44.44,0,0,0,0,.1c.05.31.11.63.17.94.17.82.38,1.65.62,2.47l.18.56s0,0,0,0,.09.29.14.43a31.4,31.4,0,0,0,1.34,3.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,395.12c.05.09.09.18.14.26l18.43-9a.3.3,0,0,0,.13-.4.3.3,0,0,0-.39-.13l-18.43,9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.39,371.67l8.85-4.34a.27.27,0,0,0,.1-.08.29.29,0,0,0,0-.31.3.3,0,0,0-.33-.15l-.06,0-7.72,3.78,0,0c-.29.32-.56.65-.82,1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.55,375l11.64-5.7a.3.3,0,0,0,.14-.39.31.31,0,0,0-.4-.13l-11,5.39A8.75,8.75,0,0,0,323.55,375Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.38,379l14.19-6.95a.29.29,0,0,0,.13-.39.3.3,0,0,0-.39-.13l-13.79,6.75C322.47,378.55,322.42,378.79,322.38,379Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.06,383l16-7.85a.29.29,0,0,0,.13-.39.3.3,0,0,0-.39-.13l-15.77,7.72C322.06,382.6,322.05,382.81,322.06,383Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4,387.07l17.35-8.5a.29.29,0,0,0,.13-.39.3.3,0,0,0-.39-.13l-17.18,8.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.39,391.15l18.16-8.9.06,0a.29.29,0,0,0,.07-.35.29.29,0,0,0-.39-.13l-18.08,8.85.18.56S323.39,391.14,323.39,391.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.76,409.19c.47,0,.93,0,1.39,0l7.72-3.78A.29.29,0,0,0,353,405a.29.29,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,408.62c.3.08.59.16.89.22l11-5.4a.29.29,0,0,0-.25-.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.1,407.05l.65.34,13.8-6.76a.3.3,0,0,0,.13-.39.29.29,0,0,0-.39-.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.74,404.86l.49.37,0,0L349,397.53a.27.27,0,0,0,.1-.08.29.29,0,0,0,0-.31.28.28,0,0,0-.39-.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.76,402.11l.43.45,17.18-8.42a.3.3,0,0,0,.13-.39.29.29,0,0,0-.39-.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.15,398.83l.34.48,18.08-8.85a.3.3,0,0,0,.13-.39.29.29,0,0,0-.39-.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.25,366.69l-.4-.83a5.87,5.87,0,0,0-.65.26l-3,1.46a13,13,0,0,0-4,3l0,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.11,373.76l11-5.38-.59-1.2-9.06,4.43,0,.06A14.24,14.24,0,0,0,324.11,373.76Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.61,377.91l13.82-6.77-1-2L323.54,375A19.63,19.63,0,0,0,322.61,377.91Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.09,381.58l15.69-7.69-.82-1.66-14.64,7.17C322.21,380.11,322.13,380.84,322.09,381.58Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.15,385.06l17-8.34-.81-1.67-16.29,8C322.06,383.7,322.09,384.37,322.15,385.06Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.59,388.11l17.87-8.75-.41-.83-17.63,8.64C322.47,387.48,322.53,387.8,322.59,388.11Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,391.58,342,382.53l-.2-.42-18.42,9s0,0,0,0S323.48,391.44,323.53,391.58Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.58,398l.12.19.45.68.08.12.12.17.14.19.13.2h0c.23.32.47.63.71.94h0l.06.08.46.56.31.36.43.48.16.19.14.14.22.23.07.08.17.17h0l.28.29h0l0,0c.32.31.63.6,1,.89l.22.19.75.62.15.13.22.16.24.18,0,0h0l.24.17h0l.35.24.15.11.71.47.06,0c.25.16.51.31.77.46l.27.15.33.18.15.08.26.13.24.13.33.15.28.12.54.23.31.13.51.19.35.12.43.14.45.13.06,0,.21.05.61.15.07,0,.45.08.25.05.79.12.22,0,.6.05.25,0h1.69c.23,0,.45,0,.68-.06l.18,0,.58-.09.24-.05.6-.13.14,0c.25-.06.49-.13.73-.21l.2-.07.54-.2.21-.09c.24-.09.48-.2.71-.31l3-1.46c1-.49,1.66-1.21,1.6-1.69a.65.65,0,0,0,0-.13L335.6,366a.31.31,0,0,0-.09-.11v0a1.87,1.87,0,0,0-1.65,0L344.19,387l-18.05,8.85c-.18-.33-.35-.67-.52-1-5.38-11-3.17-23.15,4.92-27.39l-.32.15c-8.33,4.08-10.67,16.42-5.23,27.54.17.34.34.68.52,1h0v0l0,0c.15.29.3.56.46.84a2.75,2.75,0,0,1,.17.29Zm7.28,7,15.42-7.55.11.23-15.3,7.49Zm-2.88-2.5,16.75-8.2.17.34-16.63,8.15Zm-2.73-3.22,17.68-8.66.51,1L329,400.13C328.72,399.83,328.48,399.52,328.25,399.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,393.14c5.45,11.13,16.62,16.84,25,12.75s10.68-16.41,5.23-27.54-16.62-16.84-25-12.75S323.6,382,329.05,393.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.14,
    cy: 385.75,
    rx: 14.11,
    ry: 18.83,
    transform: "translate(-134.58 190.67) rotate(-26.09)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,393.14c5.44,11.13,16.62,16.84,25,12.75,5.6-2.74,8.49-9.19,8.14-16.51a28.32,28.32,0,0,0-2.91-11c-5.45-11.12-16.63-16.84-25-12.75-7.07,3.46-9.82,12.85-7.18,22.42h0A29.18,29.18,0,0,0,329.05,393.14Zm.5-.25a29.4,29.4,0,0,1-1.36-3.27c-3.39-9.8-.83-19.8,6.42-23.35,8.06-3.94,18.86,1.58,24.12,12.33a26.83,26.83,0,0,1,2.84,12.31c-.14,6.38-2.91,11.87-7.89,14.31C345.62,409.17,334.82,403.64,329.55,392.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.14,384.12c-.53-6.45,1.9-12.21,6.79-14.61,7-3.43,16.38,1.37,20.95,10.71a24,24,0,0,1,2.33,7.85,23.78,23.78,0,0,0-2.39-8.53c-4.58-9.34-14-14.14-21-10.71C330.8,371.31,328.37,377.4,329.14,384.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,393.14c5.44,11.13,16.62,16.84,25,12.75,5.6-2.74,8.49-9.19,8.14-16.51-.17.49-.36,1-.58,1.53-.14,6.38-2.91,11.87-7.89,14.31-8.06,3.95-18.86-1.58-24.13-12.33a29.4,29.4,0,0,1-1.36-3.27c-.4-.56-.76-1.1-1.09-1.6A29.18,29.18,0,0,0,329.05,393.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M349.74,394.45l1.2,2.78-1.66.17-.72-.52-.47-2.23a13.84,13.84,0,0,1-6.58-2.07l.55-2.08a9.75,9.75,0,0,0,4.87,1.47l-2.15-5c-1.51-.26-4.52-1.16-5.78-2.54a11.22,11.22,0,0,1-1-2c-1.1-2.53-.55-4.89,2.45-5.59l-.27-3.5.72.53,1.19,2.75a21.24,21.24,0,0,1,4.05.56l.72.53.25,2.59a10,10,0,0,0-3.86-1l2.16,5a32.2,32.2,0,0,1,3.73,1,8.62,8.62,0,0,1,3.13,3.53C353.32,391.39,352.75,393.73,349.74,394.45ZM343.49,384l-1.91-4.42a1.62,1.62,0,0,0-1.07,2.47C341,383.25,342.13,383.71,343.49,384Zm6.24,5.34c-.52-1.22-1.66-1.69-3.06-2l1.9,4.39A1.59,1.59,0,0,0,349.73,389.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M349,393.93l1.2,2.77-1.66.18-1.19-2.76a10.81,10.81,0,0,1-5.86-1.54l-.17-2.6a9.74,9.74,0,0,0,4.87,1.46l-2.15-5c-2.54-.43-5.33-1.08-6.82-4.53-1.1-2.53-.55-4.89,2.45-5.59l-1.22-2.8,1.67-.17,1.19,2.75a10.18,10.18,0,0,1,4.77,1.09l.25,2.59a10,10,0,0,0-3.86-1l2.16,5c2.54.44,5.37,1.05,6.86,4.5C352.6,390.86,352,393.2,349,393.93Zm-6.25-10.45-1.91-4.41a1.61,1.61,0,0,0-1.07,2.46C340.3,382.73,341.41,383.18,342.77,383.48Zm6.24,5.34c-.52-1.21-1.66-1.69-3.06-2l1.9,4.39A1.59,1.59,0,0,0,349,388.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.61,381.62l-33-8.65a14,14,0,0,1,6.67-7.37c8.34-4.09,19.52,1.62,25,12.75A29.49,29.49,0,0,1,360.61,381.62Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.44,386.78A22.42,22.42,0,1,1,303,364.36,22.42,22.42,0,0,1,325.44,386.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.02,
    cy: 386.78,
    r: 18.82,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77,381.33h0a22.43,22.43,0,1,0,.67,5.45A22.42,22.42,0,0,0,324.77,381.33ZM303,408.45a21.67,21.67,0,1,1,21.67-21.67A21.64,21.64,0,0,1,303,408.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,378.73a18.82,18.82,0,0,0-33.69,16.76A18.82,18.82,0,1,1,320,378.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.44,386.78A22.42,22.42,0,0,1,283.59,398c.49.36,1,.73,1.59,1.12a21.67,21.67,0,0,0,39.22-15.83c.15-.68.27-1.32.37-1.92A22.29,22.29,0,0,1,325.44,386.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.65,396.94V400h-2.26l-.64-.64.64-2.41a14.65,14.65,0,0,1-7.37-2.92l1.88-2.14a10.48,10.48,0,0,0,5.49,2.09v-5.5c-1.82-.44-5.22-1.72-6.08-3.33a7.44,7.44,0,0,1-.24-2.22c0-2.81,2-5.25,6.32-5.67l1.62-3.74.64.64v3.05a27.17,27.17,0,0,1,4.94,1l.64.64-1.13,2.77a11.36,11.36,0,0,0-4.45-1.48v5.55a39,39,0,0,1,4.3,1.44,5.64,5.64,0,0,1,2.07,4.09C311,394.08,309,396.5,304.65,396.94Zm-2.26-11.77v-4.89c-1.95.3-2.77,1.29-2.77,2.5S300.8,384.71,302.39,385.17Zm5.12,6.35c0-1.34-1.21-2-2.86-2.44v4.86C306.65,393.64,307.51,392.71,307.51,391.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M304,396.3v3.08h-2.26v-3.05a12.12,12.12,0,0,1-6.73-2.28l1.24-2.78a10.52,10.52,0,0,0,5.49,2.09v-5.5c-3.05-.74-6.32-1.73-6.32-5.55,0-2.8,2-5.25,6.32-5.66v-3.11H304v3a11.84,11.84,0,0,1,5.58,1.68L308.46,381a11.25,11.25,0,0,0-4.45-1.48v5.55c3.05.75,6.38,1.71,6.38,5.53C310.39,393.44,308.32,395.86,304,396.3Zm-2.26-11.76v-4.9c-1.95.3-2.77,1.29-2.77,2.5S300.16,384.07,301.75,384.54Zm5.12,6.35c0-1.35-1.21-2-2.86-2.45v4.86C306,393,306.87,392.07,306.87,390.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,371.3l-33.32,30a22.42,22.42,0,0,1,33.32-30Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.88,313.67q0,.69,0,1.35l0,.53c0,.53.1,1.07.17,1.59l.06.29q.11.68.27,1.32c0,.16.07.31.11.46.13.5.28,1,.45,1.47l.09.22c.15.42.33.82.51,1.22.07.13.13.27.2.4a14.69,14.69,0,0,0,.72,1.29l.1.15c.24.37.5.72.77,1.07l.27.33a14.1,14.1,0,0,0,1,1.05l.1.09a12.16,12.16,0,0,0,1,.86l.34.25a13.57,13.57,0,0,0,1.21.75l0,0h0l3.91,2.08c.22.12.45.23.68.33l.2.09.12.05.26.11.15.06.2.07.59.2.1,0h0l.14,0,.59.16.23.05.08,0,.27.05.22,0,.17,0,.66.09h.07l.24,0,.54,0h1.06l.59,0h.23l.14,0,.62-.07.26,0,.44-.07.6-.12.07,0,.2,0,.06,0,.45-.11.43-.12.35-.11.21-.07.23-.08.06,0,.31-.11.54-.21.28-.12.33-.13.65-.31.33-.17.27-.14.65-.35.11-.07h0l.05,0,.72-.44.15-.1.35-.22.2-.14,0,0,.49-.35.15-.12c.26-.19.51-.38.76-.59h0c.21-.16.41-.34.61-.51l.58-.5,0,0,.3-.28.17-.16.43-.42.17-.18.44-.46.31-.34.47-.54.06-.07c.25-.29.5-.59.74-.89a1.33,1.33,0,0,1,.14-.19l.13-.18.13-.17.09-.11.46-.66.12-.17.18-.27L257,321a.41.41,0,0,0,.05-.09l.18-.27.49-.8v-.05c.14-.23.28-.47.41-.72,0-.08.09-.16.13-.25a2.15,2.15,0,0,0,.14-.26c.28-.55.55-1.1.8-1.66l.23-.56c.13-.32.27-.63.39-.95l.16-.42h0c0-.05,0-.11.05-.16a.49.49,0,0,0,0-.11l.1-.27c.17-.51.32-1,.46-1.54,0-.14.08-.29.11-.43l.12-.43c.07-.31.14-.62.2-.93a.29.29,0,0,0,0-.09l.06-.3s0-.07,0-.11l0-.18q.12-.69.21-1.38a1.34,1.34,0,0,0,0-.2c0-.36.06-.72.09-1.07s0-.48,0-.71,0-.22,0-.32,0-.13,0-.19v-.13c0-.27,0-.53,0-.79s0-.55,0-.82a1.09,1.09,0,0,0,0-.18c0-.39-.06-.77-.11-1.15,0-.12,0-.24,0-.36s0-.16,0-.24,0-.1,0-.15,0-.22-.05-.32-.05-.27-.08-.4-.09-.41-.14-.61l-.15-.63c-.09-.34-.2-.68-.31-1-.07-.19-.12-.39-.19-.58l0-.07h0c-.1-.29-.21-.56-.33-.83l-.18-.39a.41.41,0,0,0-.05-.09c-.06-.14-.13-.26-.2-.39-.17-.34-.36-.67-.55-1-.08-.14-.17-.27-.25-.4l-.14-.22a.21.21,0,0,0,0-.06c-.17-.25-.36-.48-.54-.72l-.2-.25s0,0,0,0l0,0a11.58,11.58,0,0,0-1-1l-.32-.29c-.28-.25-.56-.49-.86-.71l-.36-.27a14,14,0,0,0-1.29-.8L251.16,290h0l-1-.54h0c-4-2.15-8.83-1.91-13.34.21a26.07,26.07,0,0,0-11.6,11.48l0,.06c-.3.57-.57,1.14-.83,1.72-.08.16-.15.32-.22.49-.25.59-.49,1.17-.69,1.76,0,.07,0,.15-.08.22-.18.53-.34,1.07-.49,1.6-.05.17-.1.35-.14.52-.15.58-.28,1.16-.39,1.73l-.06.34c-.08.49-.15,1-.2,1.45a5.43,5.43,0,0,0-.06.55c0,.1,0,.19,0,.29,0,.46-.06.92-.07,1.38Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,402.93c.1-.1.19-.21.29-.32.29-.34.56-.69.82-1.06l.11-.15c.28-.41.54-.84.78-1.28l.21-.41c.2-.39.39-.8.57-1.22l.09-.22q.29-.72.51-1.47c0-.16.09-.32.13-.48.12-.43.23-.87.32-1.32,0-.1.05-.2.07-.31.09-.52.17-1.06.23-1.6,0-.18,0-.36,0-.54,0-.45.06-.91.07-1.37,0-.13,0-.26,0-.39q0-.71,0-1.41a2.83,2.83,0,0,0,0-.29c0-.19,0-.37,0-.56,0-.49-.1-1-.16-1.48,0-.12,0-.23-.05-.35q-.13-.88-.33-1.77c0-.18-.09-.36-.13-.54-.13-.55-.28-1.1-.45-1.64l-.06-.23c-.1-.3-.2-.6-.31-.9h0l-.09-.23c-.08-.23-.17-.46-.26-.69s-.11-.3-.18-.45-.1-.26-.16-.39c-.18-.45-.39-.89-.6-1.33,0-.06-.05-.11-.07-.16v0a30.17,30.17,0,0,0-1.76-3.11c-5.86-9-15.68-13.33-23.21-9.65l0,0-3.38,1.66a.88.88,0,0,0-.33-.07H313.94l0,0h14.56a.94.94,0,0,0,.94-.93v-8.62a.94.94,0,0,0-.07-.34.93.93,0,0,0-.87-.59h2a.93.93,0,0,0,.93-.93v-8.62a1,1,0,0,0-.06-.35,1,1,0,0,0-.87-.59h-2a.94.94,0,0,0,.94-.94v-8.62a1,1,0,0,0-.07-.34.93.93,0,0,0-.87-.59h-6.63a.9.9,0,0,0,.43-.57l2.14-8.35a1,1,0,0,0,0-.35l-.13,0h0l.13,0a.93.93,0,0,0-.7-.78l-.26-.07h0l-40.61-10.43h0l-.26-.07a.93.93,0,0,0-1.14.67l-2.06,8.05a16.78,16.78,0,0,0-7.15,1.69A26.07,26.07,0,0,0,260.67,337a.16.16,0,0,0,0,.07c-.3.56-.57,1.13-.83,1.71l-.21.49c-.26.59-.49,1.17-.7,1.76,0,.08-.05.15-.07.22-.18.53-.35,1.07-.49,1.6-.05.17-.1.35-.14.52-.15.58-.29,1.16-.39,1.73,0,.12,0,.23-.06.35q-.12.72-.21,1.44l-.06.55,0,.29c0,.46-.06.92-.07,1.38,0,.13,0,.25,0,.38q0,.69,0,1.35c0,.18,0,.35,0,.53,0,.54.09,1.07.17,1.59,0,.1,0,.2,0,.3.08.44.17.88.27,1.31,0,0,0,.07,0,.1l-28.41,4.57a.94.94,0,0,0-.77,1.07l.31,1.91.25,1.56.77,4.81h0l0,.24a.94.94,0,0,0,.1.28l.09,0h0l-.09,0a.93.93,0,0,0,1,.49h0l-.19.22-.13.15-.22.26a17.94,17.94,0,0,0-1.34,1.83l-.08.12a25.53,25.53,0,0,0-1.37,2.41v.05a27.86,27.86,0,0,0-2.71,12.18c0,.47,0,.94,0,1.4a3,3,0,0,0,0,.31c0,.37,0,.74.08,1.1l0,.32c.07.63.15,1.26.26,1.87L223.37,394l-7.27,7.36h0l-.17.17a.93.93,0,0,0,0,1.32l6.13,6.06a.81.81,0,0,0,.24.17l.07-.07h0l-.07.07a1,1,0,0,0,1.08-.18l6.49-6.56.13.18h0c.25.33.5.64.76.95l.1.12c.22.26.44.51.67.75a1.29,1.29,0,0,1,.16.17q.39.4.81.78h0c.28.26.57.5.87.74l.14.11.75.55.19.13a15.85,15.85,0,0,0,1.88,1.06l.18.08c.27.12.54.24.81.34l.22.08a13,13,0,0,0,2,.56l.22,0c.28.05.56.08.85.11l.24,0c.35,0,.7.05,1.06.05h4.51c.26,0,.52,0,.77,0l.23,0h.12l.29,0H248l.21,0,.62-.11.11,0h0l.14,0,.6-.14.24-.07.08,0,.27-.08.21-.07.17-.06.64-.23.06,0,.23-.1.49-.22.25-.12.23-.12c.09,0,.18-.1.27-.15l.21-.12.07,0v.92a.73.73,0,0,0,0,.3.93.93,0,0,0,.88.64h76.11a.94.94,0,0,0,.93-.94v-4.8l.88.79.59.48.15.13.28.21.18.13,0,0,0,0,.2.15.35.24.15.11.71.47.06,0h0l.11.07.65.39.27.15.33.18.66.34.32.15.28.12.54.23.31.13.07,0,.23.08.21.08.35.12.43.14.45.13.06,0c.3.08.59.16.89.22l.45.08.25.05.63.1.14,0h0l.22,0,.6.05.25,0h1.69c.23,0,.45,0,.68-.06l.18,0,.22,0,.27-.05h.09l.24-.05.6-.13.14,0h0l.1,0,.62-.18.2-.07.15-.06.27-.1.12,0,.21-.09c.24-.09.48-.2.71-.31l4-2h0l.05,0a12.94,12.94,0,0,0,1.26-.73l.35-.24a11.4,11.4,0,0,0,1.1-.84l.1-.08A12.88,12.88,0,0,0,357.91,402.93ZM322,398.69h4.43a.92.92,0,0,0,.51-.17l.12.19H322Zm-29.9-31.49h-4.05a.91.91,0,0,0-.75.4H277l.17,0,.44-.07c.3-.05.59-.11.88-.18l.06,0,.45-.11.42-.12.35-.11.21-.07.23-.08.07,0,.31-.11.54-.21.27-.12.33-.13.65-.31.33-.17.28-.14c.22-.11.43-.23.64-.35l.12-.07h0l.05,0c.25-.14.49-.28.72-.44l.16-.09.34-.23h0v1.87a.94.94,0,0,0,.93.93h6.13Zm-27.28-3.06.05,0h0l3.9,2.08q.34.18.69.33l.2.09.11.05.27.11.15.06.19.07.6.2.09,0h0l.14,0,.59.15.23.05.09,0,.26,0,.22,0,.18,0H255.16l-.12-.09,0,0-.35-.26,0,0c-.32-.24-.64-.47-1-.67l-.07,0c-.23-.14-.46-.28-.7-.41l10.29-1.66Zm31.28-28.45c0-.07-.05-.13-.07-.2s-.12-.39-.19-.58c0,0,0-.05,0-.07h0c-.11-.29-.22-.56-.34-.83s-.11-.26-.17-.39a.41.41,0,0,1-.05-.09c-.07-.14-.14-.26-.2-.39-.18-.34-.36-.67-.56-1-.08-.14-.16-.27-.25-.4l-.13-.22,0-.06c-.17-.25-.36-.48-.55-.72-.06-.08-.12-.17-.19-.25l0,0,0,0c-.3-.36-.62-.69-.95-1l-.33-.29c-.27-.25-.56-.49-.85-.71l-.37-.27-.35-.24,30.29,7.78Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.55,
    y: 253.95,
    width: 17.28,
    height: 145.43,
    rx: 3.12,
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.7 291.01 367.7 322.04 365.63 322.58 349.02 326.91 345.32 327.88 272.92 346.79 265.33 317.73 346.3 296.59 350.14 295.59 365.63 291.55 367.7 291.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.87,330.14c-1.34-5.14-9.42-.54-10.43-4.41-.37-1.41.48-2.86,3.06-3.53a7.41,7.41,0,0,1,4.18.16l.19-1.33a8.21,8.21,0,0,0-4.7-.1c-3.59.93-4.74,3.15-4.2,5.23,1.37,5.22,9.44.57,10.45,4.44.36,1.4-.5,2.8-3.14,3.49a7.15,7.15,0,0,1-5.1-.49l-.29,1.3a7.9,7.9,0,0,0,5.72.46C290.22,334.42,291.41,332.22,290.87,330.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.07,317.42l-1.47.39-2.77,15.8,1.56-.4.71-4.22,7.86-2.05,2.68,3.33,1.57-.41Zm-1.74,10.22,1.4-8.47,5.37,6.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.37,312.65l-2.25,13.68-8.6-10.85-1.62.42,9.94,12.49,1.47-.39,2.57-15.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,311.33l-1.49.39,3.69,14.12,1.49-.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5,321.17l-3.69-14.12-1.47.38,3,11.46-12.09-9.08-1.23.32,3.69,14.12,1.49-.39-3-11.46,12.07,9.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.63,309.94l-1.44.37,1.25,4.76a6.34,6.34,0,0,1-3.41,2.05,6.72,6.72,0,0,1-2.54.18,5.79,5.79,0,0,1-3.75-2,6.13,6.13,0,0,1-1.27-2.46,5.82,5.82,0,0,1,1.53-5.76,6.5,6.5,0,0,1,3-1.67,8.15,8.15,0,0,1,.83-.17,5.77,5.77,0,0,1,3.85.71l.68-1.19a6.66,6.66,0,0,0-4.41-.91,8.5,8.5,0,0,0-1.36.25,8.94,8.94,0,0,0-2.44,1h0a7.19,7.19,0,0,0-3.14,8.08,7.37,7.37,0,0,0,2.76,4.15,7.26,7.26,0,0,0,3.77,1.36,8.73,8.73,0,0,0,2.79-.27,8,8,0,0,0,4.71-3.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.63,307.18c-2.84-.38-6.54.72-7.2-1.81-.37-1.41.48-2.86,3.07-3.54a7.5,7.5,0,0,1,4.13.15h0l.2-1.32-.24-.07a8.35,8.35,0,0,0-4.47,0c-3.59.94-4.73,3.15-4.19,5.23,1,3.95,5.91,2.25,8.66,2.88a2.09,2.09,0,0,1,1.79,1.57c.29,1.12-.21,2.25-1.79,3a7.27,7.27,0,0,1-1.35.48,7.17,7.17,0,0,1-5.11-.5l-.28,1.3a7.89,7.89,0,0,0,5.72.47c.36-.1.7-.2,1-.32a6.47,6.47,0,0,0,2.07-1.22v-5.52A4.31,4.31,0,0,0,365.63,307.18Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingMoney);
export default __webpack_public_path__ + "static/media/saving-money.c0e105c83ab8815c95281b58b3a39a2d.svg";
export { ForwardRef as ReactComponent };